import zhLocale from "../../../node_modules/element-ui/lib/locale/lang/zh-CN";
const zh = {
  // 头部
  navbar: {
    home: "首页",
    list: [
      {
        name: "帳戶資訊",
        type: 1,
        img: require("../../assets/img/login/account.png")
      },
      {
        name: "退出登錄",
        type: 3,
        img: require("../../assets/img/login/out.png")
      }
    ],
    logOut: "退出登錄",
    accountInformation: "帳戶資訊",
    login: "登錄",
    register: "註冊",
    ProductSystem: "產品體系",
    solution: "解決方案",
    price: "價格",
    AboutUs: "關於我們",
    title: "創造無限連接",
    dropList: [
      // {
      //   name: "DCI互聯",
      //   names: "SD-DCI",
      //   img1: require("../../assets/img/header/DCI.png"),
      //   img: require("../../assets/img/header/DCI.png"),
      //   imgs: require("../../assets/img/header/DCI2.png"),
      //   type: 1
      // },
      {
        name: "MSP",
        names: "MSP",
        img1: require("../../assets/img/header/DCI.png"),
        img: require("../../assets/img/header/DCI.png"),
        imgs: require("../../assets/img/header/DCI2.png"),
        type: 1
      },
      {
        name: "雲專線",
        names: "SD-Cloud 1",
        img1: require("../../assets/img/header/cloud1.png"),
        img: require("../../assets/img/header/cloud1.png"),
        imgs: require("../../assets/img/header/cloud.png"),
        type: 2
      },
      {
        name: "定向加速",
        names: "DA",
        img1: require("../../assets/img/header/speed.png"),
        img: require("../../assets/img/header/speed.png"),
        imgs: require("../../assets/img/header/speed2.png"),
        type: 3
      },
      {
        name: "SD-WAN",
        names: "SD-WAN",
        img1: require("../../assets/img/header/SD-WAN.png"),
        img: require("../../assets/img/header/SD-WAN.png"),
        imgs: require("../../assets/img/header/SD-WAN2.png"),
        type: 4
      }
    ],
    solutList: [
      {
        name: "混合雲方案",
        img1: require("../../assets/img/header/headhunhe.png"),
        img: require("../../assets/img/header/headhunhe.png"),
        imgs: require("../../assets/img/header/headhunhe2.png"),
        type: 1
      },
      {
        name: "企業私有網",
        img1: require("../../assets/img/header/headsiyou.png"),
        img: require("../../assets/img/header/headsiyou.png"),
        imgs: require("../../assets/img/header/headsiyou2.png"),
        type: 2
      }
    ],
    aboutus: [
      {
        name: "公司簡介",
        img1: require("../../assets/img/header/conpy1.png"),
        img: require("../../assets/img/header/conpy1.png"),
        imgs: require("../../assets/img/header/conpy2.png"),
        type: 1
      },
      {
        name: "服務承諾",
        img1: require("../../assets/img/header/serve1.png"),
        img: require("../../assets/img/header/serve1.png"),
        imgs: require("../../assets/img/header/serve2.png"),
        type: 2
      }
    ]
  },
  // 底部
  footer: {
    Services: "聯系我們",
    phonetext: "7*24*365小時保障電話：",
    telphone: "852-5123-4372",
    address: "地址：香港九龍旺角花園街2-16號好景商業中心12楼19室",
    email: "郵箱：noc@zhtd.hk",
    saleemail:"銷售郵箱：sales@zhtd.hk",
    productSystem: "產品體系",
    DCIInterconnected: "DCI互聯",
    CloudLine: "雲專線",
    DirectionalAcceleration: "定向加速",
    SDWAN: "SD-WAN",
    solution: "解決方案",
    cloud: "混合雲方案",
    conty: "企業私有網",
    about: "關於我們",
    intro: "公司簡介",
    service: "服務承諾",
    weixin: "扫一扫关注我们"
  },
  // 首页
  main: {
    title: "高速 穩定 安全",
    text:
      "基於中慧通達SDN高可用網絡，打造DC-DC、DC-雲、雲-雲之間無障礙連接網絡",
    texttitle:
      "中慧通達致力於打造中國領先的生態網絡服務，堅持以客戶至上、創新務實、不忘初心、以誠爲本的企業價值觀",
    texttitles:
      "基於行業特性，中慧通達以安全爲先，穩定爲本，整合行業資源，爲各行業提供針對性解決方案，佈局生態網絡平臺",
    product: "產品介紹",
    textlist: [
      {
        name: "MSP",
        img: require("../../assets/img/main/DCI.png"),
        title:
          "基於天弛與國內外多家雲廠家的深入合作，為客戶提供不同雲廠家從雲諮詢到雲監控的多場景雲系統服務能力。",
        btn: "了解更多",
        type: 1
      },
      {
        name: "雲專線",
        img: require("../../assets/img/main/cloud.png"),
        title:
          "提供的高速、安全、穩定的專線連接服務，基於中慧通達SDN平臺滿足網內不同地域POP節點-公有云、公有云-公有云的互聯需求。",
        btn: "了解更多",
        type: 2
      },
      {
        name: "定向加速",
        img: require("../../assets/img/main/JS.png"),
        title:
          "定向加速是中慧通達提供的高速、安全、穩定的專線連接服務，基於中慧通達SDN平臺滿足網內不同地域定向加速需求",
        btn: "了解更多",
        type: 3
      },
      {
        name: "SD-WAN",
        img: require("../../assets/img/main/SD-WAN.png"),
        title:
          "提供的高速、安全、穩定的連接服務，基於中慧通達SD-WAN網絡滿足網內不同地域互聯需求。",
        btn: "了解更多",
        type: 4
      }
    ],
    case: "客戶案例",
    caselist: [
      {
        name: "MSP產品案例",
        img: require("../../assets/img/main/DCIcase.png"),
        title: "基於天弛與國內外多家雲廠家的深入合作，為客戶提供不同雲廠家從雲諮詢到雲監控的多場景雲系統服務能力",
        type: 1
      },
      {
        name: "雲專線產品案例",
        img: require("../../assets/img/main/cloudCase.png"),
        title: "幫助企業快速構建高質量的連接公有云的專有網絡",
        type: 2
      },

      {
        name: "定向加速產品案例",
        img: require("../../assets/img/main/speedCase.png"),
        title: "基於中慧通達SDN高可用網絡平臺滿足客戶不同定向加速的需求",
        type: 3
      },
      {
        name: "SD-WAN產品案例",
        img: require("../../assets/img/main/SD-WANcase.png"),
        title:
          "基於中慧通達SD-WAN高可用網絡滿足客戶總部與分支機構的互聯需求，幫助企業快速組網",
        type: 4
      }
    ],
    create: "創造無限連接",
    partner: "堅持合作與服務至上",
    serve: "服務客戶",
    join: "合作伙伴",
    overseas: "海外合作基礎設施",
    open: "已開發區域",
    data: [
      { name: "中國", value: [104.195397, 35.86166, 1], data: "" },
      { name: "日本", value: [139.252924, 39.204824], data: "" },
      { name: "韓國", value: [127.766922, 35.907757], data: "" },
      { name: "法國", value: [2.213749, 45.227638], data: "" },
      { name: "德國", value: [14.451526, 48.165691], data: "" },
      { name: "美國", value: [-95.712891, 37.09024], data: "" },
      { name: "英國", value: [-2.235973, 56.378051], data: "" },
      { name: "荷蘭", value: [5.291265999999999, 52.132633], data: "" },
      { name: "新加坡", value: [101.975766, 4.210484], data: "" }
    ]
  },
  // 产品体系-DCI
  // projectdci: {
  //   title: "DCI互聯",
  //   text: "數據中心之間專線互聯，高速暢達",
  //   textlist: [
  //     {
  //       name: "高速互通",
  //       img: require("../../assets/img/product/spes.png")
  //     },
  //     {
  //       name: "穩定可靠",
  //       img: require("../../assets/img/product/stab.png")
  //     },
  //     {
  //       name: "安全",
  //       img: require("../../assets/img/product/save.png")
  //     },
  //     {
  //       name: "按需購買",
  //       img: require("../../assets/img/product/buy.png")
  //     }
  //   ],
  //   header: "DCI簡介",
  //   matter:
  //     "DCI業務是中慧通達提供的高速、安全、穩定的專線連接服務，基於中慧通達SDN網絡滿足網內不同地域DC-DC的互聯需求。幫助企業快速構建高質量私有網絡，實現DCI等多種場景的網絡融合",
  //   about:
  //     "依靠中慧通達SDN高可用網絡技術，可以將不同廠商公有云連通，兩側直接進行高速內網通信，不再需要繞行公網。即使兩側遠隔千里，也可以享受到內網通信一般的低延遲和高帶寬",
  //   feature: "產品特色",
  //   about2:
  //     "中慧通達SDN高可用網絡產品依託中慧通達全球骨幹網基礎設施實現，保障您的網絡間通信穩定可靠",
  //   about3:
  //     "中慧通達SDN高可用網絡在網絡虛擬化層通信，所有通信數據在中慧通達自建設施中傳輸，且多租戶互相隔離，讓您的私密數據免去傳輸過程中被竊取的風險",
  //   about4:
  //     "中慧通達SDN高可用網絡產品提供不同帶寬的規格。您可以根據您的業務需求按需購買，成本可控",
  //   spelist: [
  //     {
  //       name: "單點接入，全網貫通",
  //       img: require("../../assets/img/product/04.png"),
  //       title:
  //         "連接中慧通達的任一節點即可獲得與多個網絡提供應用商的連接條件。企業通過擴容帶寬即可滿足業務增量需求，避免建設多條鏈路"
  //     },
  //     {
  //       name: "多地域接入",
  //       img: require("../../assets/img/product/05.png"),
  //       title:
  //         "中慧通達提供覆蓋華北、華東、華南、港澳臺及海外的100多個POP節點，企業可根據自身業務需求選擇就近節點接入"
  //     },
  //     {
  //       name: "可視化管理",
  //       img: require("../../assets/img/product/06.png"),
  //       title: "在線自助開通，業務可視化管理"
  //     },
  //     {
  //       name: "快速開通",
  //       img: require("../../assets/img/product/01.png"),
  //       title: "最快3天建立DC節點直連"
  //     },
  //     {
  //       name: "按需配置",
  //       img: require("../../assets/img/product/02.png"),
  //       title: "1Mbps-10Gbps同帶寬可調支持彈性增長"
  //     },
  //     {
  //       name: "實時監測",
  //       img: require("../../assets/img/product/03.png"),
  //       title: "實時網絡監控及監測提供流量報告"
  //     }
  //   ],
  //   scene: "應用場景",
  //   menustitle: "兩地三中心容災",
  //   text2: [
  //     {
  //       title:
  //         "通過中慧通達DCI產品，在同城數據中心節點上建立備份，可以實現服務和數據快速恢復；在異地數據中心節點上建立備份，避免發生自然災害等意外時導致數據丟失"
  //     }
  //   ],
  //   menustitles: "解決的問題",
  //   menulists: [
  //     {
  //       title:
  //         "全程採用中慧通達SDN高可用網絡，實現兩地三中心互聯，保證數據實時同步"
  //     },
  //     {
  //       title: "全面保障服務和數據安全，提升服務可用率"
  //     }
  //   ],
  //   case: "客戶案例",
  //   demand: "客戶需求",
  //   serviceList: [
  //     {
  //       name: "客戶北京和上海分別有數據中心，需要實時數據備份"
  //     }
  //   ],
  //   solution: "解決方案",
  //   serviceLists: [
  //     {
  //       name: "客戶兩地數據中心均在中慧通達SDN高可用網絡的POP節點上"
  //     },
  //     {
  //       name: "通過兩地數據中心機房內跳線，客戶設備接入中慧通達SDN高可用網絡上"
  //     },
  //     {
  //       name:
  //         "客戶可以實現數據實時備份，可快速恢復，避免發生自然災害等意外時導致數據丟失"
  //     }
  //   ]
  // },
  projectdci: {
    title: "MSP",
    text: "一站式雲系統遷移、部署、監控服務",
    textlist: [
      {
        name: "雲諮詢",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "雲部署",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "雲遷移",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "雲監控",
        img: require("../../assets/img/product/yun.png")
      }
    ],
    header: "MSP簡介",
    matter:
      "基於天弛與國內外多家雲廠家的深入合作，為客戶提供不同雲廠家從雲諮詢到雲監控的多場景雲系統服務能力",
    about:
      "從客戶接觸到產品選型階段提供專業化的產品使用指導，同時在業務系統設計方案提供成熟的方案設計體系",
    feature: "產品特色",
    about2:"面向業務應用的落地實施操作，可以針對客戶業務架構進行相對應的應用部署操作。滿足在多種場景模塊的部署方案",
    about3:"針對混合雲、IDC上雲、雲數據遷移等不同場景設計針對性操作方案及遷雲管理，實現用戶低損或無損遷移操作",
    about4:"根據客戶使用的業務應用給出相對應的監控方案，配合雲上的監控及撥測做到多方面的問題發現",
    spelist: [
      {
        name: "多場景的科技支撐能力",
        img: require("../../assets/img/product/04.png"),
        title:
          ""
      },
      {
        name: "全方面的應用部署能力",
        img: require("../../assets/img/product/05.png"),
        title:
          ""
      },
      {
        name: "成熟的架構遷移能力",
        img: require("../../assets/img/product/06.png"),
        title: ""
      },
      {
        name: "可靠的問題發現能力",
        img: require("../../assets/img/product/02.png"),
        title: ""
      },
      // {
      //   name: "按需配置",
      //   img: require("../../assets/img/product/02.png"),
      //   title: "1Mbps-10Gbps同带宽可调支持弹性增长"
      // },
      // {
      //   name: "实时监测",
      //   img: require("../../assets/img/product/03.png"),
      //   title: "实时网络监控及监测提供流量报告"
      // }
    ],
    scene: "應用場景",
    menustitle: "按遷移方案劃分",
    text2: [
      {
        title:
          "熱遷移：需要建設專線進行明確的模塊遷移規劃，耗時長業務影響低，遷雲風險係數大。"
      },
      {
        title:"冷遷移：可接受有損的業務切換，可在集成測試後進行全量切換，遷移時間週期較短，遷雲風險係數低。"
      }
    ],
    menustitles: "按遷移場景劃分",
    menulists: [
      {
        title: "跨雲遷移：不同雲產品功能及設備類型適配，在售前POC階段需要進行大量的功能性測試。"
      },
      {
        title: "IDC遷移：最常見的遷雲模式，僅需要確認IDC業務調用邏輯，設備適配可按照雲廠家方案提供，遷移難度較小。"
      }
    ],
    case: "客戶案例",
    demand: "客戶需求",
    serviceList: [
      {
        name: "【MSP售前場景】針對腰部及中長尾的小型金融客戶需要使用雲上和本地資源做混合雲以及本地私有化部署的場景需要提供專業的產品使用和選型建議，以及架構設計方案的諮詢；"
      },
      {
        name:"【MSP售中場景】對於已經確認使用雲或私有化部署，但是需要進行部署和遷移服務時沒有人力和操作經驗金融客戶；"
      }
    ],
    solution: "解決方案",
    serviceLists: [
      {
        name: "售前階段提供專業的服務部署諮詢服務，引導用戶按模塊、服務做後業務分拆實現高內聚低耦合高可用架構邏輯；"
      },
      {
        name: "售中過程提供一站式的業務部署服務，助力金融客戶在多雲環境和IDC環境下的邏輯層和數據層和網路層的部署簡單完成；"
      }
    ]
  },
  projectcloud: {
    title: "雲專線",
    text:
      "中慧通達提供高速、安全、穩定的雲專線服務，實現數據中心、私有云、公有云之間的專線網絡連接",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "穩定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需購買",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "雲專線簡介",
    matter:
      "雲專線是中慧通達提供的高速、安全、穩定的專線連接服務，基於中慧通達骨幹網滿足網內不同地域POP節點-POP節點、POP節點-公有云、公有云-公有云的互聯需求。結合最後一公里連接服務，可將雲專線延伸至用戶寫字樓或數據中心，幫助企業快速構建高質量私有網絡，實現DCI、ECI等多種場景的網絡融合",
    about:
      "依靠中慧通達SDN高可用網絡技術，可以將不同廠商公有云連通，兩側直接進行高速內網通信，不再需要繞行公網。即使兩側遠隔千里，也可以享受到內網通信一般的低延遲和高帶寬",
    about2:
      "中慧通達SDN高可用網絡產品依託中慧通達全球骨幹網基礎設施實現，保障您的網絡間通信穩定可靠",
    about3:
      "中慧通達SDN高可用網絡在網絡虛擬化層通信，所有通信數據在中慧通達自建設施中傳輸，且多租戶互相隔離，讓您的私密數據免去傳輸過程中被竊取的風險",
    about4:
      "中慧通達SDN高可用網絡產品提供不同帶寬的規格。您可以根據您的業務需求按需購買，成本可控",
    feature: "產品特色",
    spelist: [
      {
        name: "單點接入，全網貫通",
        img: require("../../assets/img/product/04.png"),
        title:
          "連接中慧通達的任一節點，即可獲得與多個網絡供應商的連接條件，企業通過擴容帶寬即可滿足業務增量需求，避免建設多條鏈路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "中慧通達提供覆蓋華北、華東、華南、港澳臺及海外的100多個POP節點，企業可根據自身業務需求選擇就近節點接入"
      },
      {
        name: "多場景接入",
        img: require("../../assets/img/product/07.png"),
        title:
          "雲專線產品支持阿里雲、騰訊雲、AWS等主流公有云、IDC節點之間的兩兩互聯，滿足企業多場景的專線連接需求"
      },
      {
        name: "快速開通",
        img: require("../../assets/img/product/01.png"),
        title:
          "SDN高可用網絡與公有云、私有云、行業雲平臺API自動化對接全面支持混合雲網絡虛擬專線互聯客戶自服務系統，支持一鍵操作、秒級開通"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title:
          "支持固定寬帶包月的計費策略支持基於寬帶+時長的計費策略支持基於流量的計費策略"
      },
      {
        name: "實時監測",
        img: require("../../assets/img/product/03.png"),
        title: "實時網絡監控及監測，提供流量報告"
      }
    ],
    scene: "應用場景",
    menustitle: "雙雲雙活架構",
    text2: [
      {
        title:
          "基於中慧通達骨幹網絡與公有云資源，通過線上自助實現跨雲環境的網絡融合，助力雙雲雙活架構快速落地"
      }
    ],
    menustitles: "解決的問題",
    menulists: [
      {
        title:
          "全程採用專線連接，保證網絡穩定、高速，數據實時同步，提升用戶體驗"
      },
      {
        title:
          "通過中慧通達SDN高可用網絡平臺按需調度網絡資源，實現網絡的彈性分配"
      }
    ],
    case: "客戶案例",
    demand: "客戶需求",
    serviceList: [
      {
        name: "客戶需要從某地公有云到某地公有云做直連雲業務"
      },
      {
        name: "需要2條1G鏈路或者1條2G鏈路，確認不同方案和報價"
      },
      {
        name:
          "2條1G鏈路需要具備不同的傳輸路徑，實現冗餘互備，同時做負載均衡；或2條2G鏈路具備不同的傳輸路徑，實現冗餘互備"
      },
      {
        name:
          "穩定底層線路——通過城網穩定可靠的特點，提供全面冗餘高可用的網絡架構"
      }
    ],
    solution: "解決方案",
    serviceLists: [
      {
        name: "中慧通達SDN高可用網絡與公有云、私有云、行業雲平臺API自動化對接"
      },
      {
        name: "中慧通達SDN高可用網絡全面支持混合雲網絡虛擬專線互聯"
      },
      {
        name: "客戶數據直接經由中慧通達SDN高可用網絡實現公有云之間互聯"
      },
      {
        name: "客戶業務通過中慧通達SDN高可用網絡實現公有云之間互通"
      },
      {
        name: "鏈路備份，確保故障點降至最少"
      }
    ]
  },
  projectDA: {
    title: "定向加速",
    text: "本地接入中慧通達SDN高可用網絡直達資源池",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "穩定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需購買",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "定向加速簡介",
    matter:
      "定向加速是中慧通達提供的高速、安全、穩定的專線連接服務，基於中慧通達SDN高可用網絡滿足網內不同地域定向加速需求",
    about:
      "依靠中慧通達SDN高可用網絡技術，可以將不同廠商公有云連通，兩側直接進行高速內網通信，不再需要繞行公網。即使兩側遠隔千里，也可以享受到內網通信一般的低延遲和高帶寬",
    about2:
      "中慧通達SDN高可用網絡產品依託中慧通達全球骨幹網基礎設施實現，保障您的網絡間通信穩定可靠",
    about3:
      "中慧通達SDN高可用網絡在網絡虛擬化層通信，所有通信數據在中慧通達自建設施中傳輸，且多租戶互相隔離，讓您的私密數據免去傳輸過程中被竊取的風險",
    about4:
      "中慧通達SDN高可用網絡產品提供不同帶寬的規格。您可以根據您的業務需求按需購買，成本可控",
    feature: "產品特色",
    spelist: [
      {
        name: "單點接入，全網貫通",
        img: require("../../assets/img/product/04.png"),
        title:
          "連接中慧通達的任一節點即可獲得與多個網絡提供應用商的連接條件。企業通過擴容帶寬即可滿足業務增量需求，避免建設多條鏈路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "中慧通達提供覆蓋華北、華東、華南、港澳臺及海外的100多個POP節點，企業可根據自身業務需求選擇就近節點接入"
      },
      {
        name: "可視化管理",
        img: require("../../assets/img/product/06.png"),
        title: "在线自助开通，业务可视化管理"
      },
      {
        name: "快速開通",
        img: require("../../assets/img/product/01.png"),
        title: "最快三天建立連接"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title: "1Mbps-10Gbps同带宽可调支持弹性增长"
      },
      {
        name: "實時監測",
        img: require("../../assets/img/product/03.png"),
        title: "實時網絡監控及監測提供流量報告"
      }
    ],
    scene: "應用場景",
    menustitle: "",
    text2: [],
    menustitles: "定向加速",
    menulists: [
      {
        title:
          "採用中慧通達SDN高可用網絡連接直接接入應用，提升網絡連接質量，降低網絡延遲和丟包率，保證客戶的良好應用體驗"
      },
      {
        title:
          "通過中慧通達SDN高可用網絡進行網絡資源的配置與彈性管理，承載高併發訪問壓力"
      },
      {
        title:
          "中慧通達在全球多地區部署IDC節點、互聯雲節點，能支持全球同服架構的部署"
      },
      {
        title:
          "基於中慧通達骨幹網絡架構，提供安全隧道，並結合DDoS高防，保證網絡傳輸安全"
      }
    ],
    case: "客戶案例",
    demand: "客戶需求",
    serviceList: [
      {
        name: "兩端地址 - A-end：瀋陽 Z-end：深圳"
      },
      {
        name: "瀋陽至深圳要求供應商POP之間時延小於85ms"
      },
      {
        name: "提供端到端帶寬1G鏈路"
      },
      {
        name: "深圳端可以提供接入騰訊雲服務器"
      }
    ],
    solution: "解決方案",
    serviceLists: [
      {
        name: "中慧通達通過專線將瀋陽機房與深圳POP節點進行打通"
      },
      {
        name: "中慧通達提供深圳本地互聯網出口，用於瀋陽網吧用戶訪問深圳遊戲使用"
      },
      {
        name: "當地網吧可以通過專線或者本地互聯網接入深圳機房"
      },
      {
        name: "網吧出口需要有設備可以區分本地遊戲（網絡）路由和深圳遊戲路由"
      },
      {
        name: "所有深圳路由通過中慧通達提供專線進行訪問"
      }
    ]
  },
  projectsd: {
    title: "SD-WAN",
    text: "部署企業輕鬆WAN管理服務",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "穩定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需購買",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "SD-WAN簡介",
    matter:
      "SD-WAN是中慧通達提供的高速、安全、穩定的連接服務，基於中慧通達SD-WAN網絡滿足網內不同地域互聯需求。幫助企業快速構建高質量私有網絡，實現辦公室加速和大型集團公司組網等多種場景",
    about:
      "依靠中慧通達SDN高可用網絡技術，可以將不同廠商公有云連通，兩側直接進行高速內網通信，不再需要繞行公網。即使兩側遠隔千里，也可以享受到內網通信一般的低延遲和高帶寬",
    about2:
      "中慧通達SDN高可用網絡產品依託中慧通達全球骨幹網基礎設施實現，保障您的網絡間通信穩定可靠",
    about3:
      "中慧通達SDN高可用網絡在網絡虛擬化層通信，所有通信數據在中慧通達自建設施中傳輸，且多租戶互相隔離，讓您的私密數據免去傳輸過程中被竊取的風險",
    about4:
      "中慧通達SDN高可用網絡產品提供不同帶寬的規格。您可以根據您的業務需求按需購買，成本可控",
    feature: "產品特色",
    spelist: [
      {
        name: "單點接入，全網貫通",
        img: require("../../assets/img/product/04.png"),
        title:
          "連接中慧通達的任一節點即可獲得與多個網絡提供應用商的連接條件。企業通過擴容帶寬即可滿足業務增量需求，避免建設多條鏈路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "中慧通達提供覆蓋華北、華東、華南、港澳臺及海外的100多個POP節點，企業可根據自身業務需求選擇就近節點接入"
      },
      {
        name: "網絡管理簡單",
        img: require("../../assets/img/product/08.png"),
        title:
          "通過集中式portal自動部署流量規則，使用一個簡單界面設置和管理各種網絡連接，實現實時網絡狀況可視化，零接觸配置快速部署"
      },
      {
        name: "快速部署",
        img: require("../../assets/img/product/09.png"),
        title: "客戶網絡接入SD-WAN設備後，自動開通"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title: "1Mbps-10Gbps同帶寬可調支持彈性增長"
      },
      {
        name: "實時監測",
        img: require("../../assets/img/product/03.png"),
        title: "實時網絡監控及監測，提供流量報告"
      }
    ],
    scene: "應用場景",
    menustitle: "",
    text2: [],
    menustitles: "大型公司組網",
    menulists: [
      {
        title:
          "例如某大型集團公司在全國地區擁有多家分公司，採用中慧通達SD-WAN網絡實現集團組網"
      },
      {
        title:
          "客戶端部署一臺SD-WAN的CE設備，就近以接入在的互聯的SD-WAN POP節點上"
      },
      {
        title:
          "使用中慧通達SD-WAN CE設備，基於Internet實現各分公司與中慧通達SD-WAN的POP點的 “最後一公里”連接"
      }
    ],
    case: "客戶案例",
    demand: "客戶需求",
    serviceList: [
      {
        name: "通過中慧通達SD-WAN網絡提供跨地域、跨網傳輸"
      }
    ],
    solution: "解決方案",
    serviceLists: [
      {
        name: "在用戶核心（總部或IDC）部署CPE節點"
      },
      {
        name: "分支機構通過現有互聯網，與中慧通達POP節點建立隧道"
      },
      {
        name: "通過中慧通達SDN高可用網絡實現各個節點之間互聯互通"
      }
    ]
  },
  // 解决方案
  cloudSolution: {
    title: "混合雲方案",
    text: "打造雲端無障礙連接",
    header: "混合雲解決方案",
    master:
      "依託中慧通達雲連接的公有云、數據中心等混合雲產品，提供混合雲基礎設施的設計、部署實施、安全管理和智能運維的全生命週期服務，幫助企業輕鬆快速搭建自己所需要的混合雲架構",
    businessRequire: "業務需求",
    businessList: [
      {
        name: "實現公有云與數據中心、私有云等不同資源的高效互通"
      },
      {
        name:
          "將中心化的公有云資源與能力實現本地化，提高計算效率，從而提升應用體驗"
      },
      {
        name:
          "混合雲網絡架構較爲複雜，簡化混合雲基礎設施的落地過程，且對網絡質量的要求較高"
      }
    ],
    solutions: "解決方案",
    solutionList: [
      {
        name:
          "基於中慧通達雲專線的公有云集羣，深度融合中慧通達的連接能力、混合雲產品服務能力，打造混合雲產業新生態，助力數據容災備份解決方案等的快速落地"
      },
      {
        name:
          "爲企業提供混合雲基礎設施設計、部署與實施、安全與智能運維的全生命週期服務，使企業輕鬆快速定製混合雲方案"
      }
    ],
    advantage: "優勢",
    textlist: [
      {
        name: "可用性",
        img: require("../../assets/img/solute/01.png"),
        title:
          "雲計算並不能保證服務永遠正常，但公有云通常會比大多數本地基礎設施具有更高的可用性。雲內置有冗餘功能並提供關鍵數據的geo-replication",
        type: 1
      },
      {
        name: "敏捷性",
        img: require("../../assets/img/solute/02.png"),
        title:
          "混合雲使您能夠將資源和工作負載從本地遷移到雲，反之亦然。對於開發和測試而言，混合雲使開發人員能夠輕鬆搞定新的虛擬機和應用程序，而無需IT運維人員的協助",
        type: 2
      },
      {
        name: "降低成本",
        img: require("../../assets/img/solute/03.png"),
        title:
          "降低成本是雲計算最吸引人的優勢之一，也是驅使企業管理層考慮雲服務的重要因素。混合雲可以幫助企業降低成本，利用“即用即付”雲計算資源來消除購買本地資源的需求",
        type: 3
      },

      {
        name: "可擴展性",
        img: require("../../assets/img/solute/04.png"),
        title:
          "混合云爲企業擴展存儲提供了經濟高效的方式，雲存儲的成本相比等量本地存儲要低得多，是備份、複製VM和數據歸檔的不錯選擇。除此之外，增加雲存儲沒有前置成本和本地資源需求",
        type: 4
      }
    ],
    serve: "一站式混合雲服務",
    matterservice:
      "中慧通達提供專業的業務諮詢、數據中心託管、專線網絡互聯、互聯網帶寬、硬件代購及代維等服務，滿足不同行業的網絡需求，一站式解決企業的網絡困擾",
    mixtureline: "混合雲專線",
    mixturezoo: "混合雲生態",
    mixedcoud:
      "通過調用API，在中慧通達SDN高可用網絡中實現公有云之間的互聯，無需線下操作，即可實現混合雲私有網絡的敏捷交付，此外，還可實現企業、數據中心與雲的快速連接",
    ecology:
      "中慧通達網內連接主流雲服務商，並與阿里雲、騰訊雲等公有云服務商合作深度定製混合雲完整解決方案"
  },
  contySolution: {
    title: "企業私有網",
    text: "公司總部與分公司組網的高速互通",
    header: "企業私有網",
    master:
      "中慧通達基於SD-WAN骨幹網資源，提供企業總部與分支組網服務，實現不同地區、 不同規模的分支機構間的高速、高質量通信，打造安全、協同、互聯的辦公網絡，大幅提升企業與分支機構的業務互通效率",
    businessRequire: "業務需求",
    businessList: [
      {
        name: "保證企業網的安全性與保密性，避免內部數據外泄"
      },
      {
        name: "實現總部與各分支之間的資源共享與數據實時同步，更好的保證協同工作"
      }
    ],
    solutions: "解決方案",
    solutionList: [
      {
        name:
          "藉助中慧通達廣泛覆蓋的全球POP節點，實現企業就近接入，並完成大陸及海外各自區域內分支機構的互聯"
      },
      {
        name:
          "基於龐大的公有云、數據中心等資源，提供混合網絡架構、跨數據中心專線互聯與混合雲專線互聯服務，實現靈活一體的基礎設施環境"
      }
    ],
    advantage: "優勢",
    textlist: [
      {
        name: "降低成本",
        img: require("../../assets/img/solute/05.png"),
        title:
          "採用中慧通達技術，利用中慧通達SDN高可用骨幹網絡和SD-WAN產品，主要應用使用專線，非主要應用使用備線網絡，節約專線流量，有效降低成本",
        type: 1
      },
      {
        name: "優化路由和提高可用性",
        img: require("../../assets/img/solute/06.png"),
        title:
          "通過雙網雙用，讓設備/線路/網絡全面冗餘，增強網絡系統的安全性和可靠性",
        type: 2
      },
      {
        name: "資源高效利用",
        img: require("../../assets/img/solute/07.png"),
        title:
          "基於中慧通達骨幹網絡技術，讓不同的應用走不同的網絡線路，充分利用企業的現有網絡資源，提升網絡帶寬利用率",
        type: 3
      },
      {
        name: "一站式服務",
        img: require("../../assets/img/solute/08.png"),
        title:
          "中慧通達提供線路和設備申請/安裝/調試/運維等一站式服務，7*24小時的專家運維團隊售後支持服務，快速響應客戶的需求，解決問題",
        type: 4
      }
    ],
    serve: "企業私有網服務",
    serviceList: [
      {
        img: require("../../assets/img/solute/alile.png"),
        title: "靈活組網",
        name:
          "可根據企業不同分支機構的地域分佈、規模大小以及實際網絡需求等，提供靈活的組網方式；可通過不同的接入方式接入到中慧通達的POP點，可接受運營商專線，裸纖，SD-WAN，機房內跳線等不同的接入方式"
      },
      {
        img: require("../../assets/img/solute/global.png"),
        title: "服務範圍覆蓋全球",
        name:
          "網絡覆蓋全球的100多家數據中心節點、是30+IDC服務商是合作伙伴關係，構建的龐大資源池，整合骨幹網絡資源，幫助企業實現大陸及海外各自區域內的網絡能力的延伸，併爲企業提供優質的網絡體驗"
      },
      {
        img: require("../../assets/img/solute/usebale.png"),
        title: "線路穩定、可用率高",
        name:
          "繞過公共互聯網的不可靠性，提供穩定的網絡訪問速度，並通過路由優化與協議優化方式保證服務的高可用性，可用率可到99.95%"
      },
      {
        img: require("../../assets/img/solute/network.png"),
        title: "統一的網絡管理",
        name:
          "企業總部與分支機構的網絡形成一個完整的網絡，便於全程監控和實現二層網絡故障自切換，實現了企業網絡的統一管控"
      }
    ]
  },
  // 关于我们
  company: {
    title: "中慧通達",
    text: "打造領先的生態網絡服務",
    header: "香港中慧通達科技有限公司",
    about: "關於我們",
    aboutList: [
      {
        name: "成立於2013年1月，致力於打造中國高端的電信增值業務服務商"
      },
      {
        name:
          "經營業務包括：中國互聯網接入、中國企業VPN、DC-DC直連、DC-Cloud直連、SD-WAN連接、企業網絡代維等服務"
      },
      {
        name: "在中國並提供基於SD-WAN的混合式雲VPN的接入服務"
      },
      {
        name: "北京、 廣州 、上海提供三地NOC運維團隊，7*24*365全方位運維服務"
      },
      {
        name: "中國超過30家渠道同行業合作模式，打造全方位開放式生態合作模式"
      },
      {
        name: "具備中國固網傳輸和增值業務運營牌照"
      }
    ],
    identity: "資質認證",
    textlist: [
      {
        name: "電信牌照",
        img: require("../../assets/img/us/identify07.png")
      }
    ],
    advantage: "合作伙伴",
    look: "查看更多",
    retract: "收起",
    serve: "聯繫我們",
    connect: [
      {
        imgs: require("../../assets/img/us/04.png"),
        call: require("../../assets/img/us/CALL us.png"),
        phone: "7*24*365小時保障電話：",
        tel: "852-5123-4372",
        componey:"公司名：香港中慧通達科技有限公司",
        add: "地址：香港九龍旺角花園街2-16號好景商業中心12楼19室"
      }
    ],
    map:'(示例图)'
  },
  promise: {
    title: "中慧通達堅持合作",
    text: "服務至上、創新務實、以誠爲本",
    header: "服務體系",
    textlist: [
      {
        name: "網管保障服務",
        litext: [
          {
            title: "24 x 7 主動式監控設備與鏈路"
          },
          {
            title: "問題根源分析和故障管理"
          },
          {
            title: "性能、配置、資產管理"
          },
          {
            title: "網絡動態分析、報表、建議"
          }
        ],
        type: 1
      },
      {
        name: "設備維護服務",
        litext: [
          {
            title: "多廠家產品的現場和備件服務"
          },
          {
            title: "事件收集、關聯、上報"
          },
          {
            title: "遠程配置"
          },
          {
            title: "安全防護報告"
          },
          {
            title: "現場工程師"
          }
        ],
        type: 3
      }
    ],
    textlists: [
      {
        name: "電話技術支持服務",
        litext: [
          {
            title: "全年365天，每天7×24 服務熱線"
          },
          {
            title: "多廠家產品支持，單一聯絡點"
          },
          {
            title: "問題上報"
          }
        ],
        type: 2
      },
      {
        name: "故障處理相應SLA指標",
        litext: [
          {
            title: "首通故障響應電話——10分鐘"
          },
          {
            title: "首封故障郵件——30分鐘"
          },
          {
            title: "故障進度反饋——60分鐘"
          }
        ],
        type: 4
      }
    ]
  },
  // 价格
  price: {
    title: "連接一觸即發",
    header: "開啓您的連接之旅",
    btnstart: "創建起點",
    btnend: "創建終點",
    taptitle: "查詢價格",
    texttitle: "測試線路",
    band: "帶寬範圍：",
    bandrange: [
      {
        id: "1",
        name: "小于",
        names: "100M",
        namesnum1: "",
        namesnum2: "100"
      },
      {
        id: "2",
        name: "100M",
        names: "-500M",
        namesnum1: "100",
        namesnum2: "500"
      },
      {
        id: "3",
        name: "500M",
        names: "-1G",
        namesnum1: "500",
        namesnum2: "1000"
      },
      {
        id: "4",
        name: "大于",
        names: "1G",
        namesnum1: "1000",
        namesnum2: ""
      }
    ],
    selectband: "選擇帶寬：",
    radio: "其他需求",
    radios: "提交查看價格",
    detail: "配置詳情",
    startconfig: "起點配置：",
    cloudtype: "雲類型：",
    country: "國家：",
    area: "地區：",
    data: "數據中心：",
    endconfig: "終點配置：",
    basisconfig: "基礎配置：",
    bandline: "寬帶：",
    monthmoney: "月租價：",
    none: "未找到該線路價格",
    moneydetail: "價格明細：",
    linemoney: "線路費用：",
    unit: "元/月",
    cloudmoneyall: "雲端口費用(總)：",
    nonecloud: "未找到該雲價格",
    nonecurmoney: "一次性服務費：",
    ele: "元",
    tel: "以上價格僅供參考，詳情致電：852-5123-4372",
    relocation: "重新配置",
    aftersale: "提交售後",
    packnum: "輸入包數：",
    packtext: "包數：",
    loss: "丢包率：",
    overtime: "延時：",
    carry: "執行",
    reset: "重置",
    month: "/月"
  },
  pricedialog: {
    // 提交成功
    dialogtext: "提交成功",
    text:
      "小主，我們已收到您的資源請求信息，將在48小時與您聯繫，祝你生活愉快！",
    config: "資源配置如下：",
    startdeploy: "起點配置：",
    enddeploy: "終點配置：",
    basisdeploy: "基礎配置：",
    refermoney: "價格（RMB）：",
    // 其他需求
    require: "提交需求",
    theme: "需求主題：",
    contacts: "聯繫人：",
    phone: "手機號：",
    remarks: "備註：",
    radiobtn:
      "注：我們收到您的需求後，將在第一時間爲您處理，保持您的通話暢通，請您耐心等待！",
    btn: "發送需求",
    // 创建起点-公有云和数据中心
    dialogTextStart: "創建起點",
    cloudtitle: "公有云",
    datatitle: "數據中心",
    cloudtype: "雲類型：",
    country: "國家",
    city: "城市",
    dataheader: "數據中心",
    back: "上一步",
    success: "確定",
    china: "中國",
    // 创建终点-公有云和数据中心
    dialogTextEnd: "創建終點"
  },
  map: {
    num1: "30+",
    datacity: "全球數據城市",
    num2: "100+",
    datacenter: "全球數據中心",
    num3: "1500+",
    dataport: "全球數據端口",
    tips: "溫馨提示：",
    tipsone: "本報價均爲我方資源可達節點",
    tipstwo: "本報價均不包含客戶至數據中心節點最後一公里和樓內跳線"
  },
  // 中国地图
  mapworld: {
    data: [
      { name: "北京", value: ["116.3979471", "39.9081726"] },
      { name: "上海", value: ["121.4692688", "31.2381763"] },
      { name: "天津", value: ["117.2523808", "39.1038561"] },
      { name: "重慶", value: ["106.548425", "29.5549144"] },
      { name: "河北", value: ["114.4897766", "38.0451279"] },
      { name: "山西", value: ["112.5223053", "37.8357424"] },
      { name: "遼寧", value: ["123.4116821", "41.7966156"] },
      { name: "吉林", value: ["125.3154297", "43.8925629"] },
      { name: "黑龍江", value: ["126.6433411", "45.7414932"] },
      { name: "浙江", value: ["120.1592484", "30.265995"] },
      { name: "福建", value: ["119.2978134", "26.0785904"] },
      { name: "山東", value: ["117.0056", "36.6670723"] },
      { name: "河南", value: ["113.6500473", "34.7570343"] },
      { name: "湖北", value: ["114.2919388", "30.5675144"] },
      { name: "湖南", value: ["112.9812698", "28.2008247"] },
      { name: "廣東", value: ["113.2614288", "23.1189117"] },
      { name: "海南", value: ["110.3465118", "20.0317936"] },
      { name: "四川", value: ["104.0817566", "30.6610565"] },
      { name: "貴州", value: ["106.7113724", "26.5768738"] },
      { name: "雲南", value: ["102.704567", "25.0438442"] },
      { name: "江西", value: ["115.8999176", "28.6759911"] },
      { name: "陝西", value: ["108.949028", "34.2616844"] },
      { name: "青海", value: ["101.7874527", "36.6094475"] },
      { name: "甘肅", value: ["103.7500534", "36.0680389"] },
      { name: "廣西", value: ["108.3117676", "22.8065434"] },
      { name: "新疆", value: ["87.6061172", "43.7909393"] },
      { name: "內蒙古", value: ["111.6632996", "40.8209419"] },
      { name: "西藏", value: ["91.1320496", "29.657589"] },
      { name: "寧夏", value: ["106.2719421", "38.4680099"] },
      { name: "臺灣", value: ["120.9581316", "23.8516062"] },
      { name: "香港", value: ["114.139452", "22.391577"] },
      { name: "澳門", value: ["113.5678411", "22.167654"] },
      { name: "安徽", value: ["117.2757034", "31.8632545"] },
      { name: "江蘇", value: ["118.7727814", "32.0476151"] },
      { name: "廣州", value: ["113.5107", "23.2196"] },
      { name: "石家莊", value: [114.4995, 38.1006] },
      { name: "杭州", value: [119.5313, 29.8773] },
      { name: "廊坊", value: [116.521, 39.0509] },
      { name: "南京", value: [118.8062, 31.9208] },
      { name: "武漢", value: [114.3896, 30.6628] },
      { name: "深圳", value: [114.5435, 22.5439] },
      { name: "無錫", value: [120.3442, 31.5527] },
      { name: "日本", value: [139.252924, 39.204824] },
      { name: "韓國", value: [127.766922, 35.907757] },
      { name: "法國", value: [2.213749, 45.227638] },
      { name: "德國", value: [14.451526, 48.165691] },
      { name: "美國", value: [-95.712891, 37.09024] },
      { name: "英國", value: [-2.235973, 56.378051] },
      { name: "荷蘭", value: [5.291265999999999, 52.132633] },
      { name: "新加坡", value: [101.975766, 4.210484] }
    ],
    mapdatas: [
      { name: "上海", value: [121.48, 31.22], data: "" },
      { name: "廣州", value: [113.5107, 23.2196], data: "" },
      { name: "深圳", value: [114.5435, 22.5439], data: "" },
      { name: "北京", value: [116.46, 39.92], data: "" },
      { name: "杭州", value: [119.5313, 29.8773], data: "" },
      { name: "石家莊", value: [114.4995, 38.1006], data: "" },
      { name: "武漢", value: [114.3896, 30.6628], data: "" },
      { name: "廊坊", value: [116.521, 39.0509], data: "" },
      { name: "南京", value: [118.8062, 31.9208], data: "" }
    ],
    mapdatanew: [
      { name: "上海", value: [121.48, 31.22], data: "上海新業" },
      { name: "廣州", value: [113.5107, 23.2196], data: "廣州華新園" },
      { name: "深圳", value: [114.5435, 22.5439], data: "深圳長虹" },
      { name: "北京", value: [116.46, 39.92], data: "北京夕照寺" },
      { name: "杭州", value: [119.5313, 29.8773], data: "杭州東方電子" },
      { name: "石家莊", value: [114.4995, 38.1006], data: "石家莊中信" },
      { name: "武漢", value: [114.3896, 30.6628], data: "中信武漢" },
      { name: "廊坊", value: [116.521, 39.0509], data: "河北廊坊高速機房" },
      { name: "南京", value: [118.8062, 31.9208], data: "中信南京" }
    ]
  },
  geoCoordMap: {
    上海: [121.4648, 31.2891],
    東莞: [113.8953, 22.901],
    東營: [118.7073, 37.5513],
    中山: [113.4229, 22.478],
    臨汾: [111.4783, 36.1615],
    臨沂: [118.3118, 35.2936],
    丹東: [124.541, 40.4242],
    麗水: [119.5642, 28.1854],
    烏魯木齊: [87.9236, 43.5883],
    佛山: [112.8955, 23.1097],
    保定: [115.0488, 39.0948],
    蘭州: [103.5901, 36.3043],
    包頭: [110.3467, 41.4899],
    北京: [116.4551, 40.2539],
    北海: [109.314, 21.6211],
    南京: [118.8062, 31.9208],
    南寧: [108.479, 23.1152],
    南昌: [116.0046, 28.6633],
    南通: [121.1023, 32.1625],
    廈門: [118.1689, 24.6478],
    台州: [121.1353, 28.6688],
    合肥: [117.29, 32.0581],
    呼和浩特: [111.4124, 40.4901],
    咸陽: [108.4131, 34.8706],
    哈爾濱: [127.9688, 45.368],
    唐山: [118.4766, 39.6826],
    嘉興: [120.9155, 30.6354],
    大同: [113.7854, 39.8035],
    大連: [122.2229, 39.4409],
    天津: [117.4219, 39.4189],
    太原: [112.3352, 37.9413],
    威海: [121.9482, 37.1393],
    寧波: [121.5967, 29.6466],
    寶雞: [107.1826, 34.3433],
    宿遷: [118.5535, 33.7775],
    常州: [119.4543, 31.5582],
    廣州: [113.5107, 23.2196],
    廊坊: [116.521, 39.0509],
    延安: [109.1052, 36.4252],
    張家口: [115.1477, 40.8527],
    徐州: [117.5208, 34.3268],
    德州: [116.6858, 37.2107],
    惠州: [114.6204, 23.1647],
    成都: [103.9526, 30.7617],
    揚州: [119.4653, 32.8162],
    承德: [117.5757, 41.4075],
    拉薩: [91.1865, 30.1465],
    無錫: [120.3442, 31.5527],
    日照: [119.2786, 35.5023],
    昆明: [102.9199, 25.4663],
    杭州: [119.5313, 29.8773],
    棗莊: [117.323, 34.8926],
    柳州: [109.3799, 24.9774],
    株洲: [113.5327, 27.0319],
    武漢: [114.3896, 30.6628],
    汕頭: [117.1692, 23.3405],
    江門: [112.6318, 22.1484],
    瀋陽: [123.1238, 42.1216],
    滄州: [116.8286, 38.2104],
    河源: [114.917, 23.9722],
    泉州: [118.3228, 25.1147],
    泰安: [117.0264, 36.0516],
    泰州: [120.0586, 32.5525],
    濟南: [117.1582, 36.8701],
    濟寧: [116.8286, 35.3375],
    海口: [110.3893, 19.8516],
    淄博: [118.0371, 36.6064],
    淮安: [118.927, 33.4039],
    深圳: [114.5435, 22.5439],
    清遠: [112.9175, 24.3292],
    溫州: [120.498, 27.8119],
    渭南: [109.7864, 35.0299],
    湖州: [119.8608, 30.7782],
    湘潭: [112.5439, 27.7075],
    濱州: [117.8174, 37.4963],
    濰坊: [119.0918, 36.524],
    煙臺: [120.7397, 37.5128],
    玉溪: [101.9312, 23.8898],
    珠海: [113.7305, 22.1155],
    鹽城: [120.2234, 33.5577],
    盤錦: [121.9482, 41.0449],
    石家莊: [114.4995, 38.1006],
    福州: [119.4543, 25.9222],
    秦皇島: [119.2126, 40.0232],
    紹興: [120.564, 29.7565],
    聊城: [115.9167, 36.4032],
    肇慶: [112.1265, 23.5822],
    舟山: [122.2559, 30.2234],
    蘇州: [120.6519, 31.3989],
    萊蕪: [117.6526, 36.2714],
    菏澤: [115.6201, 35.2057],
    營口: [122.4316, 40.4297],
    葫蘆島: [120.1575, 40.578],
    衡水: [115.8838, 37.7161],
    衢州: [118.6853, 28.8666],
    西寧: [101.4038, 36.8207],
    西安: [109.1162, 34.2004],
    貴陽: [106.6992, 26.7682],
    連雲港: [119.1248, 34.552],
    邢臺: [114.8071, 37.2821],
    邯鄲: [114.4775, 36.535],
    鄭州: [113.4668, 34.6234],
    鄂爾多斯: [108.9734, 39.2487],
    重慶: [107.7539, 30.1904],
    金華: [120.0037, 29.1028],
    銅川: [109.0393, 35.1947],
    銀川: [106.3586, 38.1775],
    鎮江: [119.4763, 31.9702],
    長春: [125.8154, 44.2584],
    長沙: [113.0823, 28.2568],
    長治: [112.8625, 36.4746],
    陽泉: [113.4778, 38.0951],
    青島: [120.4651, 36.3373],
    韶關: [113.7964, 24.7028],
    吐魯番: [89.18596, 42.94244],
    那曲: [92.05136, 31.47614],
    呂梁: [111.15081, 37.51761],
    伊春: [128.669, 47.72582],
    呼倫貝爾: [119.73572, 49.21336],
    嘉峪關: [98.33435281250001, 39.668377553435185],
    漢中: [107.03194, 33.06784]
  },
  GZData: [
    [
      [
        { name: "北京", value: [116.46, 39.92] },
        { name: "上海", value: [121.48, 31.22] }
      ],
      [
        { name: "武漢", value: [114.3896, 30.6628] },
        { name: "北京", value: [116.46, 39.92] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "深圳", value: [114.5435, 22.5439] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "廣州", value: [113.5107, 23.2196] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "石家莊", value: [114.4995, 38.1006] }
      ],
      [
        { name: "杭州", value: [119.5313, 29.8773] },
        { name: "石家莊", value: [114.4995, 38.1006] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "武漢", value: [114.3896, 30.6628] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "廊坊", value: [116.521, 39.0509] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "南京", value: [118.8062, 31.9208] }
      ],
      [
        { name: "上海", value: [121.48, 31.22] },
        { name: "杭州", value: [119.5313, 29.8773] }
      ],
      [
        { name: "杭州", value: [119.5313, 29.8773] },
        { name: "廣州", value: [113.5107, 23.2196] }
      ],
      [
        { name: "武漢", value: [114.3896, 30.6628] },
        { name: "廣州", value: [113.5107, 23.2196] }
      ],
      [
        { name: "深圳", value: [114.5435, 22.5439] },
        { name: "石家莊", value: [114.4995, 38.1006] }
      ]
    ]
  ],
  // 世界地图
  mapworlds: {
    data: [
      { name: "北京", value: ["116.3979471", "39.9081726"] },
      { name: "上海", value: ["121.4692688", "31.2381763"] },
      { name: "天津", value: ["117.2523808", "39.1038561"] },
      { name: "重慶", value: ["106.548425", "29.5549144"] },
      { name: "河北", value: ["114.4897766", "38.0451279"] },
      { name: "山西", value: ["112.5223053", "37.8357424"] },
      { name: "遼寧", value: ["123.4116821", "41.7966156"] },
      { name: "吉林", value: ["125.3154297", "43.8925629"] },
      { name: "黑龍江", value: ["126.6433411", "45.7414932"] },
      { name: "浙江", value: ["120.1592484", "30.265995"] },
      { name: "福建", value: ["119.2978134", "26.0785904"] },
      { name: "山東", value: ["117.0056", "36.6670723"] },
      { name: "河南", value: ["113.6500473", "34.7570343"] },
      { name: "湖北", value: ["114.2919388", "30.5675144"] },
      { name: "湖南", value: ["112.9812698", "28.2008247"] },
      { name: "廣東", value: ["113.2614288", "23.1189117"] },
      { name: "海南", value: ["110.3465118", "20.0317936"] },
      { name: "四川", value: ["104.0817566", "30.6610565"] },
      { name: "貴州", value: ["106.7113724", "26.5768738"] },
      { name: "雲南", value: ["102.704567", "25.0438442"] },
      { name: "江西", value: ["115.8999176", "28.6759911"] },
      { name: "陝西", value: ["108.949028", "34.2616844"] },
      { name: "青海", value: ["101.7874527", "36.6094475"] },
      { name: "甘肅", value: ["103.7500534", "36.0680389"] },
      { name: "廣西", value: ["108.3117676", "22.8065434"] },
      { name: "新疆", value: ["87.6061172", "43.7909393"] },
      { name: "內蒙古", value: ["111.6632996", "40.8209419"] },
      { name: "西藏", value: ["91.1320496", "29.657589"] },
      { name: "寧夏", value: ["106.2719421", "38.4680099"] },
      { name: "臺灣", value: ["120.9581316", "23.8516062"] },
      { name: "澳門", value: ["113.5678411", "22.167654"] },
      { name: "安徽", value: ["117.2757034", "31.8632545"] },
      { name: "江蘇", value: ["118.7727814", "32.0476151"] },
      { name: "廣州", value: ["113.5107", "23.2196"] },
      { name: "香港", value: ["114.139452", "22.391577"] },
      { name: "日本", value: [139.252924, 39.204824] },
      { name: "韓國", value: [127.766922, 35.907757] },
      { name: "法國", value: [2.213749, 45.227638] },
      { name: "德國", value: [14.451526, 48.165691] },
      { name: "美國", value: [-95.712891, 37.09024] },
      { name: "英國", value: [-2.235973, 56.378051] },
      { name: "荷蘭", value: [5.291265999999999, 52.132633] },
      { name: "新加坡", value: [101.975766, 4.210484] }
    ],
    mapdatas: [
      { name: "香港", value: [114.139452, 22.391577], data: "" },
      { name: "日本", value: [139.252924, 39.204824], data: "" },
      { name: "韓國", value: [127.766922, 35.907757], data: "" },
      { name: "法國", value: [2.213749, 45.227638], data: "" },
      { name: "德國", value: [14.451526, 48.165691], data: "" },
      { name: "美國", value: [-95.712891, 37.09024], data: "" },
      { name: "英國", value: [-2.235973, 56.378051], data: "" },
      { name: "荷蘭", value: [5.291265999999999, 52.132633], data: "" },
      { name: "新加坡", value: [101.975766, 4.210484], data: "" }
    ],
    mapdatanew: [
      { name: "香港", value: [114.139452, 22.391577], data: "" },
      { name: "日本", value: [139.252924, 39.204824], data: "" },
      { name: "韓國", value: [127.766922, 35.907757], data: "" },
      { name: "法國", value: [2.213749, 45.227638], data: "" },
      { name: "德國", value: [14.451526, 48.165691], data: "" },
      { name: "美國", value: [-95.712891, 37.09024], data: "" },
      { name: "英國", value: [-2.235973, 56.378051], data: "" },
      { name: "荷蘭", value: [5.291265999999999, 52.132633], data: "" },
      { name: "新加坡", value: [101.975766, 4.210484], data: "" }
    ]
  },
  geoCoordMaps: {
    香港: [114.139452, 22.391577],
    日本: [139.252924, 39.204824],
    韓國: [127.766922, 35.907757],
    德國: [14.451526, 48.165691],
    荷蘭: [5.291265999999999, 52.132633],
    新加坡: [101.975766, 4.210484],
    英國: [-2.235973, 56.378051],
    美國: [-95.712891, 37.09024],
    法國: [2.213749, 45.227638],
    上海: [121.4648, 31.2891],
    東莞: [113.8953, 22.901],
    東營: [118.7073, 37.5513],
    中山: [113.4229, 22.478],
    臨汾: [111.4783, 36.1615],
    臨沂: [118.3118, 35.2936],
    丹東: [124.541, 40.4242],
    麗水: [119.5642, 28.1854],
    烏魯木齊: [87.9236, 43.5883],
    佛山: [112.8955, 23.1097],
    保定: [115.0488, 39.0948],
    蘭州: [103.5901, 36.3043],
    包頭: [110.3467, 41.4899],
    北京: [116.4551, 40.2539],
    北海: [109.314, 21.6211],
    南京: [118.8062, 31.9208],
    南寧: [108.479, 23.1152],
    南昌: [116.0046, 28.6633],
    南通: [121.1023, 32.1625],
    廈門: [118.1689, 24.6478],
    台州: [121.1353, 28.6688],
    合肥: [117.29, 32.0581],
    呼和浩特: [111.4124, 40.4901],
    咸陽: [108.4131, 34.8706],
    哈爾濱: [127.9688, 45.368],
    唐山: [118.4766, 39.6826],
    嘉興: [120.9155, 30.6354],
    大同: [113.7854, 39.8035],
    大連: [122.2229, 39.4409],
    天津: [117.4219, 39.4189],
    太原: [112.3352, 37.9413],
    威海: [121.9482, 37.1393],
    寧波: [121.5967, 29.6466],
    寶雞: [107.1826, 34.3433],
    宿遷: [118.5535, 33.7775],
    常州: [119.4543, 31.5582],
    廣州: [113.5107, 23.2196],
    廊坊: [116.521, 39.0509],
    延安: [109.1052, 36.4252],
    張家口: [115.1477, 40.8527],
    徐州: [117.5208, 34.3268],
    德州: [116.6858, 37.2107],
    惠州: [114.6204, 23.1647],
    成都: [103.9526, 30.7617],
    揚州: [119.4653, 32.8162],
    承德: [117.5757, 41.4075],
    拉薩: [91.1865, 30.1465],
    無錫: [120.3442, 31.5527],
    日照: [119.2786, 35.5023],
    昆明: [102.9199, 25.4663],
    杭州: [119.5313, 29.8773],
    棗莊: [117.323, 34.8926],
    柳州: [109.3799, 24.9774],
    株洲: [113.5327, 27.0319],
    武漢: [114.3896, 30.6628],
    汕頭: [117.1692, 23.3405],
    江門: [112.6318, 22.1484],
    瀋陽: [123.1238, 42.1216],
    滄州: [116.8286, 38.2104],
    河源: [114.917, 23.9722],
    泉州: [118.3228, 25.1147],
    泰安: [117.0264, 36.0516],
    泰州: [120.0586, 32.5525],
    濟南: [117.1582, 36.8701],
    濟寧: [116.8286, 35.3375],
    海口: [110.3893, 19.8516],
    淄博: [118.0371, 36.6064],
    淮安: [118.927, 33.4039],
    深圳: [114.5435, 22.5439],
    清遠: [112.9175, 24.3292],
    溫州: [120.498, 27.8119],
    渭南: [109.7864, 35.0299],
    湖州: [119.8608, 30.7782],
    湘潭: [112.5439, 27.7075],
    濱州: [117.8174, 37.4963],
    濰坊: [119.0918, 36.524],
    煙臺: [120.7397, 37.5128],
    玉溪: [101.9312, 23.8898],
    珠海: [113.7305, 22.1155],
    鹽城: [120.2234, 33.5577],
    盤錦: [121.9482, 41.0449],
    石家莊: [114.4995, 38.1006],
    福州: [119.4543, 25.9222],
    秦皇島: [119.2126, 40.0232],
    紹興: [120.564, 29.7565],
    聊城: [115.9167, 36.4032],
    肇慶: [112.1265, 23.5822],
    舟山: [122.2559, 30.2234],
    蘇州: [120.6519, 31.3989],
    萊蕪: [117.6526, 36.2714],
    菏澤: [115.6201, 35.2057],
    營口: [122.4316, 40.4297],
    葫蘆島: [120.1575, 40.578],
    衡水: [115.8838, 37.7161],
    衢州: [118.6853, 28.8666],
    西寧: [101.4038, 36.8207],
    西安: [109.1162, 34.2004],
    貴陽: [106.6992, 26.7682],
    連雲港: [119.1248, 34.552],
    邢臺: [114.8071, 37.2821],
    邯鄲: [114.4775, 36.535],
    鄭州: [113.4668, 34.6234],
    鄂爾多斯: [108.9734, 39.2487],
    重慶: [107.7539, 30.1904],
    金華: [120.0037, 29.1028],
    銅川: [109.0393, 35.1947],
    銀川: [106.3586, 38.1775],
    鎮江: [119.4763, 31.9702],
    長春: [125.8154, 44.2584],
    長沙: [113.0823, 28.2568],
    長治: [112.8625, 36.4746],
    陽泉: [113.4778, 38.0951],
    青島: [120.4651, 36.3373],
    韶關: [113.7964, 24.7028],
    吐魯番: [89.18596, 42.94244],
    那曲: [92.05136, 31.47614],
    呂梁: [111.15081, 37.51761],
    伊春: [128.669, 47.72582],
    呼倫貝爾: [119.73572, 49.21336],
    嘉峪關: [98.33435281250001, 39.668377553435185],
    漢中: [107.03194, 33.06784]
  },
  GZDatas: [
    [
      [
        { name: "美國", value: [-95.712891, 37.09024] },
        { name: "荷蘭", value: [5.291265999999999, 52.132633] }
      ],
      [
        { name: "香港", value: [114.139452, 22.391577] },
        { name: "美國", value: [-95.712891, 37.09024] }
      ],
      [
        { name: "日本", value: [139.252924, 39.204824] },
        { name: "香港", value: [114.139452, 22.391577] }
      ],
      [
        { name: "日本", value: [139.252924, 39.204824] },
        { name: "韓國", value: [127.766922, 35.907757] }
      ],
      [
        { name: "荷蘭", value: [5.291265999999999, 52.132633] },
        { name: "香港", value: [114.139452, 22.391577] }
      ],
      [
        { name: "荷蘭", value: [5.291265999999999, 52.132633] },
        { name: "韓國", value: [127.766922, 35.907757] }
      ],
      [
        { name: "韓國", value: [127.766922, 35.907757] },
        { name: "新加坡", value: [101.975766, 4.210484] }
      ],
      [
        { name: "韓國", value: [127.766922, 35.907757] },
        { name: "法國", value: [2.213749, 45.227638] }
      ],
      [
        { name: "英國", value: [-2.235973, 56.378051] },
        { name: "日本", value: [139.252924, 39.204824] }
      ],
      [
        { name: "英國", value: [-2.235973, 56.378051] },
        { name: "法國", value: [2.213749, 45.227638] }
      ],
      [
        { name: "新加坡", value: [101.975766, 4.210484] },
        { name: "德國", value: [14.451526, 48.165691] }
      ],
      [
        { name: "法國", value: [2.213749, 45.227638] },
        { name: "新加坡", value: [101.975766, 4.210484] }
      ],
      [
        { name: "法國", value: [2.213749, 45.227638] },
        { name: "德國", value: [14.451526, 48.165691] }
      ],
      [
        { name: "德國", value: [14.451526, 48.165691] },
        { name: "美國", value: [-95.712891, 37.09024] }
      ]
    ]
  ],
  // 个人资料
  personal: {
    selfcony: "個人資料",
    identify: "企業認證",
    name: "賬戶名：",
    popoverone: [
      { name: "①、4-20位字符" },
      { name: "②、支持數字、字母與下劃線" },
      { name: "③、至少包含一個字母" },
      { name: "④、不支持漢字格式" }
    ],
    edit: "修改",
    save: "保存",
    cancel: "取消",
    tapbind: "點擊綁定",
    albind: "已綁定",
    password: "登錄密碼：",
    phone: "手機號：",
    email: "郵箱：",
    times: "註冊時間：",
    textMap: {
      editPwd: "修改密碼",
      editPho: "修改手機號",
      editEma: "修改郵箱",
      bindEma: "郵箱綁定",
      bindPho: "手機號綁定"
    },
    oldPwd: "舊密碼：",
    newPwd: "新密碼：",
    conPwd: "確認新密碼：",
    success: "確定",
    bindphone: "手機號",
    bindcode: "手機驗證碼",
    code: "獲取驗證碼",
    bind: "提交",
    stepData: [
      { label: "驗證身份", value: 1 },
      { label: "更改手機", value: 2 }
    ],
    editphone: "請發送驗證碼到手機號",
    phonecode: "手機驗證碼",
    codefirst: "獲取驗證碼",
    next: "下一步",
    newphone: "新手機號",
    newcode: "手機驗證碼",
    codephonesecond: "獲取驗證碼",
    bindemail: "郵箱",
    bindemailcode: "郵箱驗證碼",
    codes: "獲取驗證碼",
    stepEmail: [
      { label: "驗證身份", value: 1 },
      { label: "更改郵箱", value: 2 }
    ],
    editemail: "請發送驗證碼到郵箱",
    emailcode: "郵箱驗證碼",
    codesfirst: "獲取驗證碼",
    newemail: "新郵箱",
    newemailcode: "郵箱驗證碼",
    codesecond: "獲取驗證碼"
  },
  selfdata: {
    name: "企業名稱：",
    people: "公司聯繫人：",
    phone: "聯繫人手機號：",
    telphone: "公司預留電話：",
    address: "公司地址：",
    des: "備註：",
    save: "保存修改",
    num: "不能超過100個字"
  },
  user: {
    // 登錄
    accout: "賬號登錄",
    name: "帳號名/郵箱/手機號",
    password: "請輸入密碼",
    checked: "記住密碼",
    forgetCode: "忘記密碼？",
    login: "登錄",
    regUser: "還沒有賬號？",
    signsty: "免費註冊",
    // 退出登錄
    message: "提示",
    loginout: "是否退出登錄？",
    cancel: "取消",
    define: "確定",
    // 註冊
    sign: "歡迎註冊",
    already: "已有賬號？",
    logintap: "直接登錄",
    signphone: "手機號註冊",
    signemail: "郵箱註冊",
    success: "註冊成功，請登錄",
    backlogin: "返回登錄",
    // 忘记密码
    forgetpassword: "找回密碼",
    forgetphone: "手機號找回",
    forgetemail: "郵箱找回"
  },
  // 註冊
  signphone: {
    // 手机号註冊
    account: "賬戶名：",
    accountText: "請輸入您的賬戶名",
    popoverList: [
      { name: "①、4-20位字符" },
      { name: "②、支持數字、字母與下劃線" },
      { name: "③、至少包含一個字母" },
      { name: "④、不支持漢字格式" }
    ],
    company: "企業名稱：",
    companyText: "請輸入您所在的公司",
    company_contact: "企業聯繫人：",
    company_contact_Text: "請輸入聯繫人姓名",
    password: "密碼：",
    passwordText: "請輸入您設置的密碼",
    popoversList: [
      { name: "①、6-20位字符" },
      { name: "②、必須包含數字、字母或下劃線中的兩種" }
    ],
    rePasswords: "確認密碼：",
    rePasswordsText: "請再次輸入您設置的密碼",
    popoversr: "請保持兩次密碼的一致性",
    phone: "手機號碼：",
    phoneText: "請輸入您的手機號",
    drag: "請將滑塊拖動到右側",
    check: "驗證成功",
    verifyStatus: "請拖動滑塊進行驗證",
    clause: "《中慧通達網站服務條款》",
    privacy: "《法律聲明及隱私權政策》",
    care: "注：*爲必填項",
    agree: "同意條款並註冊",
    checkphone: "驗證手機",
    nextText: "請發送驗證碼到手機",
    phonecode: "手機驗證碼：",
    codetext: "驗證碼",
    codeStr: "獲取驗證碼",
    submit: "提交登錄",
    // 邮箱註冊
    email: "郵箱名稱：",
    emailText: "請輸入您的郵箱名稱",
    checkemail: "驗證郵箱",
    nextEmail: "請發送驗證碼到郵箱",
    emailcode: "郵箱驗證碼：",
    codeStrs: "獲取驗證碼"
  },
  // 忘记密码
  forgectPhone: {
    phone: "手機號碼",
    phoneplace: "請輸入您的手機號",
    drag: "請將滑塊拖動到右側",
    check: "驗證成功",
    verifyStatus: "請拖動滑塊進行驗證",
    text: "請發送驗證碼到手機：",
    phonecode: "手機驗證碼",
    phonetext: "請輸入驗證碼",
    codeStr: "獲取驗證碼",
    passwords: "輸入密碼",
    passwordText: "請輸入您設置的密碼",
    popovers: [
      { name: "①、6-20位字符" },
      { name: "②、必須包含數字、字母或下劃線中的兩種" }
    ],
    rePasswords: "確認新密碼",
    rePasswordsText: "請再次輸入您設置的密碼",
    popoversr: "請保持兩次密碼的一致性",
    next: "下一步",
    define: "確定",
    nonebind: "您還沒有綁定手機號，請更換驗證方式",
    passwordsuccess: "密碼找回成功",
    back: "返回登錄"
  },
  forgectEmail: {
    email: "郵箱名稱",
    emailplace: "請輸入您的郵箱名稱",
    drag: "請將滑塊拖動到右側",
    check: "驗證成功",
    verifyStatus: "請拖動滑塊進行驗證",
    text: "請發送驗證碼到郵箱：",
    emailcode: "郵箱驗證碼",
    emailtext: "請輸入驗證碼",
    codeStrs: "獲取驗證碼",
    passwords: "輸入密碼",
    passwordText: "請輸入您設置的密碼",
    popovers: [
      { name: "①、6-20位字符" },
      { name: "②、必須包含數字、字母或下劃線中的兩種" }
    ],
    rePasswords: "確認新密碼",
    rePasswordsText: "請再次輸入您設置的密碼",
    popoversr: "請保持兩次密碼的一致性",
    next: "下一步",
    define: "確定",
    nonebind: "您還沒有綁定郵箱，請更換驗證方式",
    passwordsuccess: "密碼找回成功",
    back: "返回登錄"
  },
  loginout: {
    title: "提示",
    out: "是否退出登錄？",
    cancel: "取 消",
    bind: "確 定"
  },
  // 底部备案号
  record: {
    keep: "京ICP备18008832号-1",
    permit: "增值电信业务经营许可证：A2.B1-20130273"
  },
  // 校验文字
  checkvalid: {
    password: "請輸入正確的密碼",
    phone: "請輸入正確的手機號碼",
    same: "兩次密碼輸入不一致，請重新輸入",
    code: "請輸入驗證碼",
    hd: "請將滑塊拖動到右側",
    email: "請輸入正確的郵箱",
    codesuccess: "驗證碼發送成功",
    account: "請輸入正確的賬戶名",
    company: "請輸入公司名稱",
    contact: "請輸入公司聯繫人",
    logins: "登錄成功",
    edit: "修改成功",
    oldPwd: "請輸入正確的舊密碼",
    newPwd: "請輸入正確的新密碼",
    conPwd: "請再次輸入新密碼",
    bind: "綁定成功",
    select: "請選擇",
    pack: "請輸入ping的包數",
    smallthan: "請輸入大於零小於一萬數值",
    packnum: "請輸入正確的包數",
    loss: "努力讀取中……",
    band: "請選擇帶寬",
    start: "請先創建起點",
    end: "請先創建終點",
    theme: "請輸入需求主題",
    remarks: "請輸入需求內容",
    contacts: "請輸入聯繫人姓名",
    contactsphone: "請輸入聯繫人手機號",
    text: "請輸入文字",
    require: "需求發送成功",
    dialogText: "雲端起點",
    selectcity: "請選擇城市",
    selectdata: "請選擇數據中心",
    dc: "DC端起點"
  },
  // 协议
  clause: {
    header: "中慧通達網站服務條款",
    time: "2019年12月版",
    qy: "前言",
    list: [
      {
        name: "歡迎訪問中慧通達網站並使用我們提供的產品和服務。"
      },
      {
        name:
          "在完成註冊程序或以任何方式使用中慧通達網站服務前，請您務必仔細閱讀並透徹理解本中慧通達網站服務條款(以下或簡稱“服務條款”)，在確認充分理解後選擇接受或不接受本服務條款；一旦您完成“同意條款並註冊”或開始以其他方式使用中慧通達服務，即表明您已閱讀並同意受本服務條款的約束。如您不同意本服務條款或其中任何條款約定，您應不再進行下一步或停止註冊程序。"
      },
      {
        name:
          "中慧通達再次提示您審慎閱讀、充分理解各條款內容，特別是限制或免除責任的相應條款，限制或免除責任條款將以加粗或其他醒目形式提示您注意。"
      },
      {
        name: "如果您未滿18週歲，請在法定監護人的陪同下閱讀本服務條款。"
      }
    ],
    //  一、
    one: "一、 簽約主體以及協議範圍",
    oneList: [
      {
        name:
          " 1.1. 中慧通達網站服務條款是您與北京中慧通達有限公司（“中慧通達”或者“我們”）就使用中慧通達網站服務（包含爲您提供網站頁面信息瀏覽、賬戶註冊服務等）而訂立的有效合約。"
      },
      {
        name: "中慧通達網站包含域名爲http://www.zhtd.hk/的網站。"
      },
      {
        name:
          "1.2.如您使用或購買中慧通達網站上某一具體服務，您可仍需確認具體服務對應的服務條款；請您審慎閱讀、充分理解各條款內容，選擇接受或不接受該服務條款。"
      }
    ],
    // 二、
    two: "二、賬戶的註冊、使用與安全",
    numone: "2.1. 註冊的資格",
    numoneList: [
      {
        name:
          "2.1.1. 您確認，在您完成註冊程序或以其他中慧通達允許的方式實際使用本服務時，您應當是具備完全民事權利能力和完全民事行爲能力的自然人、法人或其他組織（以下或簡稱爲“您”）。"
      },
      {
        name:
          "2.1.2. 若您是未成年人或限制民事行爲能力人，則您不具備前述主體資格，您及您的監護人應承擔因您的不當註冊行爲而導致的一切後果。"
      },
      {
        name:
          " 2.3.中慧通達在此提示，您在使用中慧通達服務期間應當遵守中華人民共和國的法律，不得危害網絡安全，不得利用中慧通達的服務從事他人侵犯名譽、隱私、知識產權和其他合法權益的活動。儘管有前述提示，中慧通達不對您使用中慧通達服務的用途和目的承擔任何責任。"
      },
      {
        name:
          "2.1.3. 您還需確保您不是任何國家、國際組織或者地域實施的貿易限制、制裁或其他法律、規則限制的對象，否則您可能無法正常註冊及使用中慧通達服務。"
      }
    ],
    numtwo: "2.2. 賬戶註冊",
    numtwoList: [
      {
        name:
          "2.2.1.當您按照註冊頁面提示填寫信息、閱讀並同意本服務條款且完成全部註冊程序後，您可獲得中慧通達賬戶併成爲中慧通達的用戶。"
      },
      {
        name:
          "2.2.2. 您在註冊時候設置或確認的賬戶名（“賬戶名稱”）及您設置的密碼，將在註冊成功後成爲您的賬戶（賬戶名稱及密碼合稱“賬戶”）。"
      },
      {
        name:
          "2.2.3. 您設置的賬戶名不得違反國家法律法規、中慧通達的管理規範或容易引起您與中慧通達身份的混淆，否則您的賬戶可能不能註冊成功或中慧通達有權經通知您後予以註銷。"
      },
      {
        name:
          " 2.2.4. 您應當按照法律法規要求或按相應頁面的提示，準確提供並及時更新您的賬戶信息，以使之真實、及時、完整和準確。如您提供的資料錯誤、不實、過時或不完整的，中慧通達可以向您發出詢問及/或要求改正的通知，您應按照中慧通達的要求配合提供或者更新相關資料。因您填寫的信息、資料不真實、不及時、不完整或不準確的，您應承擔您不能使用中慧通達賬戶（不能註冊成功、或賬戶被凍結、註銷）或您在使用過程中的後果和損失。"
      },
      {
        name:
          "2.2.5. 中慧通達可能會就某些產品或服務的開通，要求您提供更多的身份資料和信息，做進一步的身份認證或資格驗證，您的賬戶只有在通過這些認證和驗證之後，方可獲得使用相關產品或服務的資格。"
      },
      {
        name:
          " 2.2.6. 通常情況下，您的中慧通達賬戶是您在中慧通達網站進行一切活動的唯一身份標識，除非另有約定，每一箇中慧通達賬戶都可以在本網站獨立開展活動。但在下列情形下，中慧通達有權根據自己的判斷，對同一及/或關聯法律主體擁有的多箇中慧通達賬戶進行統一處理，如根據不同中慧通達賬戶在註冊、登錄、使用中的關聯信息，中慧通達判斷其實際爲同一用戶。關聯信息舉例：同一證件、同一手機號、同一支付賬號、同一設備、同一地址等。"
      }
    ],
    numthree: "2.3. 賬戶的使用和安全",
    numthreeList: [
      {
        name:
          " 2.3.1. 您有權使用您設定的賬戶登錄中慧通達網站，進而使用中慧通達提供的其他服務。"
      },
      {
        name:
          "2.3.2. 中慧通達可能會以郵件、站內信、短信或電話等方式通知您服務進展情況以及提示您進行下一步的操作。在服務過程中您應當及時登錄到中慧通達賬戶查看和進行交易操作。"
      },
      {
        name:
          " 2.3.3. 一箇中慧通達賬戶僅能對應唯一的法律主體。除非有法律明文規定、司法裁定或者經中慧通達同意的情況下，您不得以任何方式轉讓、贈與或讓他人繼承您的中慧通達賬戶。"
      },
      {
        name:
          " 2.3.4. 您的賬戶和密碼由您自行設置並由您保管，您須對您的中慧通達賬戶和密碼保密。您需確保您在每個上網時段結束時，以正確步驟離開網站。"
      },
      {
        name:
          "2.3.5. 如發現他人未經授權使用您的中慧通達賬戶和密碼，您應立即通知中慧通達；中慧通達將協助您凍結賬戶、更改密碼或進行其他安全設置；您理解中慧通達對您的請求採取行動需要合理時間，中慧通達對在採取行動前已經產生的以及由您引發的後果（包括但不限於您的任何損失）不承擔任何責任。"
      },
      {
        name:
          "2.3.6. 中慧通達亦會在網站服務端採取合理的技術措施保障賬戶的安全。"
      }
    ],
    // 三、
    three: "三、賬戶的凍結、註銷及申訴",
    three_one: "3.1. 賬戶的凍結",
    three_one_list: [
      {
        name:
          "您的中慧通達賬戶（全部或部分權限或功能）在如下情況可能被凍結（如中慧通達帳戶被限制資金轉出功能等），中慧通達將通過郵件、站內信、短信或電話等方式通知您："
      },
      {
        name:
          " 3.1.1. 基於中慧通達網站或服務運行和交易安全的需要，如您發生或可能發生破壞或試圖破壞中慧通達或中慧通達關聯公司公平交易環境或正常交易秩序的，或任何使用含有中慧通達或中慧通達關聯公司名稱、品牌且對他人有誤導嫌疑或任何使用某種中英文(全稱或簡稱)、數字、域名等意圖表示或映射與中慧通達或其關聯公司具有某種關聯的；"
      },
      {
        name:
          "3.1.2. 違反本服務條款、中慧通達網站的相關規則、規範（如交易規則、管理規範）、服務說明以及其他服務協議/條款的；"
      },
      {
        name: "3.1.3. 違反國家法律、法規、政策、法律文書的規定的；"
      },
      {
        name:
          "  3.1.4. 您遭到他人投訴，且對方已經提供了相關證據的，而您未按照我們的要求提供相反證據的；"
      },
      {
        name:
          "3.1.5. 中慧通達根據合理分析判斷您的賬戶操作、收益、兌換等存在異常的；"
      },
      {
        name: "3.1.6. 國家有權機關要求進行的凍結的；"
      },
      {
        name:
          " 3.1.7. 中慧通達合理判斷，您發生與如上行爲性質相同或產生如上類似風險的其他情況的。"
      }
    ],
    three_two: "3.2. 賬戶的註銷",
    three_two_list: [
      {
        name:
          "3.2.1. 如果出現如上第3.1條情形且情形嚴重的，或基於國家有權機關的要求，您的中慧通達賬戶（全部或部分權限或功能）將被註銷，中慧通達將通過郵件、站內信、短信或電話等方式通知您。"
      },
      {
        name:
          "3.2.2. 您理解並同意，如您連續12個月未通過賬戶登錄過中慧通達網站，且您的賬戶下不存在任何未到期的服務，中慧通達有權註銷您的賬戶，您將不能再登錄中慧通達網站。"
      }
    ],
    three_three: "3.3. 申訴",
    three_three_list: [
      {
        name:
          "發生前述賬戶凍結或註銷情況下，您應及時予以關注並可以按照程序進行申訴等後續操作："
      },
      {
        name:
          " 3.3.1. 您通過申訴程序，向中慧通達申請解除上述凍結或註銷的，爲了您的賬戶安全，您應配合如實提供身份證明及相關資料，以及中慧通達要求的其他信息或文件，以便中慧通達進行覈實。您應充分理解您的申訴並不必然被允許，中慧通達有權決定是否同意您的申訴請求。"
      },
      {
        name:
          "3.3.2. 您理解並同意，如果您拒絕如實提供身份證明及相關資料，或未能通過中慧通達審覈，中慧通達有權長期凍結該等賬戶且長期限制賬戶部分或全部功能。"
      }
    ],
    // 四
    four: "四、網站服務及規範",
    four_one:
      "4.1．您有權享受中慧通達通過本網站提供的互聯網技術服務和信息服務。您同時還應根據本服務條款以及您在購買具體服務時確認的相關條款和條件，履行及時付款、服務管理等責任。",
    four_two: "4.2. 您使用中慧通達的服務，您應保證：",
    four_one_text:
      " 4.2.1. 您使用中慧通達服務時將遵從國家、地方法律法規、行業慣例和社會公共道德，不會利用中慧通達提供的服務進行存儲、發佈、傳播如下信息和內容：",
    four_one_list: [
      {
        name: "（ⅰ）違反國家法律法規政策的任何內容（信息）；"
      },
      {
        name: "（ⅱ）違反國家規定的政治宣傳和/或新聞信息；"
      },
      {
        name: "（ⅲ）涉及國家祕密和/或安全的信息；"
      },
      {
        name: "（ⅳ）封建迷信和/或淫穢、色情、下流的信息或教唆犯罪的信息；"
      },
      {
        name: "（ⅴ）博彩有獎、賭博遊戲；違反國家民族和宗教政策的信息；"
      },
      {
        name: "（ⅵ）妨礙互聯網運行安全的信息；"
      },
      {
        name:
          "（ⅶ）侵害他人合法權益的信息和/或其他有損於社會秩序、社會治安、公共道德的信息或內容；"
      },
      {
        name:
          "（ⅷ）您同時承諾不得爲他人發佈上述不符合國家規定和/或本服務條款約定的信息內容提供任何便利，包括但不限於設置URL、BANNER鏈接等；"
      }
    ],
    four_one_text: [
      {
        name:
          "4.2.2. 不應出現任何破壞或試圖破壞網絡安全等的行爲，包括不會利用技術或其他手段破壞或擾亂本網站及中慧通達其他客戶的網站；"
      },
      {
        name:
          " 4.2.3. 您使用中慧通達網站的服務應符合本服務條款；如您違反上述保證，中慧通達除有權根據相關服務條款採取刪除信息、中止服務、終止服務的措施，並有權凍結或註銷您賬戶部分或全部功能。"
      }
    ],
    // 五、
    five: "五、隱私及個人信息的保護",
    five_list: [
      {
        name:
          "您的信任對中慧通達非常重要，中慧通達深知用戶信息安全的重要性，中慧通達將按照法律法規要求，採取安全保護措施，保護您的用戶信息安全可控。具體詳見《法律聲明及隱私權政策》。"
      }
    ],
    // 六、
    six: "六、知識產權",
    six_list: [
      {
        name:
          "6.1. 我們尊重知識產權，除非獲得了您的同意，中慧通達不會擅自使用、修改、複製、公開傳播、改變、散佈、發行或公開發表您擁有知識產權的成果。"
      },
      {
        name:
          "6.2. 任何組織或個人認爲中慧通達網站的網頁內容，如轉載文章、雲市場服務商發佈的商品信息等可能侵犯其合法權益的，可向中慧通達（http://www.zhtd.hk/）提出書面權利通知，中慧通達將在收到知識產權權利人合格通知後依法儘快處理。"
      },
      {
        name:
          "6.3. 除非另行說明，中慧通達網站Logo、“中慧通達”等文字、圖形及其組合，以及中慧通達網站的其他標識、徽記、中慧通達服務的名稱、技術文檔等的知識產權爲中慧通達及其關聯公司所有。"
      },
      {
        name:
          " 6.4. 您應尊重中慧通達和第三方的知識產權和其他合法權利/權益，並保證在發生侵犯前述權益的違法事件時，保護中慧通達及其僱員、股東、合作伙伴等免於因該等事件受到影響或損失，中慧通達保留在您侵犯中慧通達及/或其他第三方的合法權利/權益時終止向您提供服務並不退還任何款項的權利。"
      },
      {
        name: "其他具體信息詳見《法律聲明及隱私權政策》的法律聲明部分。"
      }
    ],
    seven: "七、保密",
    seven_list: [
      {
        name:
          "中慧通達承諾對您註冊賬戶時或使用中慧通達服務時提交或知悉的信息採取保密措施，不向第三方披露您的信息，除非："
      },
      {
        name:
          "7.1. 依據本服務條款或者您與中慧通達之間其他服務協議、合同、在線條款等規定可以提供的；"
      },
      {
        name: "7.2. 依據法律法規的規定或行政、司法等職權部門要求應當提供的；"
      },
      {
        name:
          "7.3. 在不違反本服務條款約定責任的前提下，該保密信息已經公開或能從公開領域獲得。"
      }
    ],
    eight: "八、出口管制",
    eight_list: [
      {
        name:
          " 雙方承諾遵守本協議所適用的聯合國、中國、美國以及其他國家出口管制法律法規。您承諾不會將中慧通達提供的產品或服務用於適用的出口管制法律法規禁止的用途。非經相關主管機關許可，您及您授權使用中慧通達產品或服務的其他個人或實體不會通過中慧通達產品或服務向適用的出口管制法律法規禁止的實體或個人提供受管控的技術、軟件或服務。"
      }
    ],
    nine: "九、信息安全事件",
    nine_list: [
      {
        name:
          " 中慧通達依據國家法律法規的要求、遵照相關安全事件處理標準管理信息安全事件。當發生涉及您相關資產的信息安全事件時，我們會依法及時將事件相關的情況通過郵件、信函、電話、推送通知等方式告知，您也可通過工單、客服電話、大客戶經理電話等方式主動聯繫我們。"
      }
    ],
    ten: "十、責任範圍和責任限制",
    ten_list: [
      {
        name:
          "10.1. 您了解並同意，您應承擔因您使用本服務、違反本服務條款或在您的賬戶下采取的任何行動而導致的任何第三方索賠。如果由此引起中慧通達及其關聯公司、員工、客戶和合作夥伴被第三方索賠的，您應負責處理，並賠償中慧通達及其關聯公司由此遭受的全部損失和責任。"
      },
      {
        name:
          "10.2. 在適用法律許可的範圍內，中慧通達不對與本服務條款有關或由本服務條款引起的任何間接的、懲罰性的、特殊的、派生的損失承擔賠償責任。"
      },
      {
        name:
          "10.3. 中慧通達在此提示，您在使用中慧通達服務期間應當遵守中華人民共和國的法律，不得危害網絡安全，不得利用中慧通達的服務從事侵犯他人名譽、隱私、知識產權和其他合法權益的活動。中慧通達不對您使用中慧通達服務的違法或違約行爲承擔任何責任。"
      },
      {
        name:
          " 10.4. 中慧通達用戶在中慧通達網站的論壇、社區以及雲市場上自行上傳、提供、發佈相關信息，包括但不限於用戶名稱、公司名稱、聯繫人及聯絡信息，相關圖片、資訊等，均由用戶自行提供，中慧通達的用戶須對其提供的前述信息依法承擔全部責任。"
      },
      {
        name:
          "10.5. 如果您通過使用中慧通達網站或獲取來自第三方的任何產品或服務，例如，中慧通達雲市場上的服務商依託雲市場向您提供服務，服務商將對其提供的服務向您負責，中慧通達對此第三方服務不承擔任何責任。"
      },
      {
        name:
          "10.6. 在某些情況下，爲了幫助您更便捷的使用中慧通達的服務，中慧通達可能會展示中慧通達的參考代碼或軟件（如屬於第三方開源軟件，您則應遵守第三方開源軟件的相關使用要求），基於相應展示頁面的使用說明，該等軟件可能允許您予以下載、進行二次開發等相關操作，您應理解並承諾，該等代碼的知識產權屬於中慧通達，您在使用時應明確表明權利人，同時，中慧通達不對您能否使用以及使用該等代碼、軟件的工作和後果負責。"
      }
    ],
    eleven: "十一、不可抗力和意外事件",
    eleven_list: [
      {
        name:
          "中慧通達的網站可能因爲下列不可抗力或意外事件無法正常運行的，中慧通達不承擔損害賠償責任："
      },
      {
        name:
          "11.1. 因自然災害、罷工、暴亂、戰爭、政府行爲、司法行政命令等不可抗力因素；"
      },
      {
        name: "11.2. 因電力供應故障、通訊網絡故障等公共服務因素；"
      },
      {
        name: "11.3. 經提前公告或通知的，中慧通達在短時間內的系統維護。"
      }
    ],
    twelve: "十二、 法律適用與管轄",
    twelve_list: [
      {
        name:
          "本服務條款之效力、解釋、變更、執行與爭議解決均適用中華人民共和國法律。因本服務條款產生之爭議應提交至北京市仲裁委員會提出仲裁。"
      }
    ],
    thirteen: "十三、通知送達",
    thirteen_list: [
      {
        name:
          " 13.1. 您理解並同意，中慧通達可通過網頁公告、電子郵件、站內信、短信、電話、系統消息以及即時通信等以上一種或多種通知方式向您發送通知，且中慧通達可以信賴您所提供的聯繫信息是完整、準確且當前有效的；上述通知在發送成功後視爲已送達。"
      },
      {
        name:
          "13.2．除非本服務條款另有約定或中慧通達與您另行簽訂的協議明確規定了通知方式，您發送給中慧通達的通知，應當通過中慧通達對外正式公佈的通信地址、傳真號碼、電子郵件地址等聯繫信息進行送達。"
      }
    ],
    fourteen: "十四、條款的更新和終止",
    fourteen_list: [
      {
        name:
          "14.1. 中慧通達有權對本服務條款及相應的服務規則內容進行變更，並將網頁公告、電子郵件、站內信、短信等方式予以公告或通知；若您在本服務條款內容變更後繼續使用本服務的，表示您已充分閱讀、理解並接受修改後的內容，也將遵循修改後的條款內容。"
      },
      {
        name:
          "14.2. 在您的賬戶註銷或經雙方協商一致終止網站服務的，本服務條款終止。"
      }
    ],
    fifteen: "十五、其他",
    fifteen_list: [
      {
        name:
          "15.1. 本服務條款由本服務條款的內容、網站相關頁面上展現的規則、規範，服務說明（含操作文檔）和您點擊確認的其他條款/條件組成，中慧通達和您均受其約束，且其中的相關名詞可相互引用、解釋。"
      },
      {
        name:
          "15.2. 本服務條款的章節標題僅爲行文方便而設，不具有法律或合同效力。"
      },
      {
        name:
          " 15.3. 本服務條款任一條款被視爲廢止、無效或不可執行，該條款應視爲可分的且不影響本服務條款及其他條款的有效性及可執行性。"
      },
      {
        name:
          "15.4. 中慧通達有權在中慧通達官網（http://www.zhtd.hk/）上發佈公告、發站內通知或郵件通知等方式將本服務的權利義務全部或者部分轉移給中慧通達的關聯公司。"
      },
      {
        name:
          "15.5. 除另有約定外，出於服務專業性考慮，中慧通達亦可能委託關聯公司或其他法律主體向您提供中慧通達網站上一項或多項具體服務，同時您可能會與該等公司訂立相關條款或條件，請您審慎閱讀、充分理解條款和條件內容，選擇接受或不接受該條款和條件。"
      },
      {
        name:
          "15.6. 本服務條款項下之保密條款、知識產權條款、法律適用與管轄條款以及性質上理應存續的其他條款（如對註冊信息的真實性保證等），不因本條款的終止而失效。"
      }
    ]
  },
  privacy: {
    header: "法律聲明及隱私權政策",
    time: "最近更新日期：2019年11月23日",
    times: "生效日期：2019年11月30日",
    ts: "提示條款",
    list: [
      {
        name:
          "您的信任對我們非常重要，我們深知用戶信息安全的重要性，我們將按照法律法規要求，採取安全保護措施，保護您的用戶信息安全可控。鑑此，中慧通達（或簡稱“我們”）制定本《法律聲明及隱私權政策》（以下或簡稱“聲明和政策”）並提醒您：在使用中慧通達網站的各項服務前，請您務必仔細閱讀並透徹理解本《法律聲明和隱私權政策》，在確認充分理解並同意後方使用相關產品和服務。一旦您開始使用中慧通達服務，將被視爲對本聲明和政策內容的接受和認可。"
      },
      {
        name:
          "如對本聲明和政策內容有任何疑問、意見或建議，您可通過中慧通達的工單、建議提交平臺與我們聯繫。"
      }
    ],
    content: "定義",
    contentList: [
      {
        name:
          "中慧通達網站：指中慧通達官網（域名爲：http://www.zhtd.hk/）。"
      },
      {
        name:
          "中慧通達：除非另有約定，指北京中慧通達有限公司是http://www.zhtd.hk/以及中慧通達客戶端的經營者。"
      },
      {
        name:
          "用戶信息：用戶信息是指您註冊中慧通達網站賬戶，使用中慧通達的服務以及中慧通達爲了向您提供服務，您提交的或者中慧通達收集的用戶會員類信息，如姓名、聯繫方式等，具體詳見隱私權政策第二條所述的信息。"
      },
      {
        name:
          "業務數據：不同於用戶信息，是指中慧通達的用戶利用中慧通達的服務上傳、下載、分發等通過中慧通達的技術服務處理的數據。"
      }
    ],
    sm: "法律聲明",
    //  一、
    one: "一、權利歸屬",
    oneList: [
      {
        name:
          " 1.1.中慧通達網站的Logo、“中慧通達”、“TESUCH”等文字、圖形及其組合，以及中慧通達網站的其他標識、徽記、中慧通達服務的名稱等爲中慧通達及其關聯公司在中國和其他國家的註冊商標。未經中慧通達書面授權，任何人不得以任何方式展示、使用或做其他處理（包括但不限於複製、傳播、展示、鏡像、上傳、下載），也不得向他人表明您有權展示、使用或做其他處理。"
      },
      {
        name:
          " 1.2.中慧通達網站所有的產品、服務、技術與所有程序（以下或簡稱“技術服務”）的知識產權均歸屬於中慧通達或歸其權利人所有。"
      }
    ],
    // 二、
    two: "二、責任限制",
    numoneList: [
      {
        name:
          "2.1.中慧通達用戶在中慧通達網站的論壇、社區以及雲市場上，自行上傳、提供、發佈相關信息，包括但不限於用戶名稱、公司名稱、聯繫人及聯絡信息，相關圖片、資訊等，該等信息均由用戶自行提供，中慧通達的用戶須對其提供的任何信息依法承擔全部責任。"
      },
      {
        name:
          "  2.2.中慧通達在此提示，您在使用中慧通達服務期間應當遵守中華人民共和國的法律，不得危害網絡安全，不得利用中慧通達的服務從事他人侵犯名譽、隱私、知識產權和其他合法權益的活動。儘管有前述提示，中慧通達不對您使用中慧通達服務的用途和目的承擔任何責任。"
      }
    ],
    // 三、
    three: "三、知識產權保護",
    three_one:
      "我們尊重知識產權，反對並打擊侵犯知識產權的行爲。任何組織或個人認爲中慧通達網站的網頁（含www.XXXXX.com網頁內容以及客戶端頁面）內容（如轉載文章、雲市場服務商發佈的商品信息等）可能侵犯其合法權益的，可以通過向中慧通達提出書面權利通知，中慧通達將在收到知識產權權利人合格通知後依法儘快處理。",
    hide: "隱私權政策",
    numthreeList: [
      {
        name:
          " 中慧通達（以下或稱爲“我們”）尊重並保護用戶信息，並且將以高度勤勉和審慎的義務對待這些信息。在您使用了中慧通達網站提供的服務時，我們將按照本隱私權政策收集、處理及披露您的信息。我們希望通過本隱私權政策向您清晰地介紹我們對您信息的處理方式，因此我們建議您完整地閱讀本隱私權政策，以幫助您了解維護自己隱私權的方式。如果您有任何疑問、意見或建議，請通過中慧通達提供的各種聯繫方式與我們聯繫。本政策將幫助您了解以下內容："
      },
      {
        name: "一、本協議的適用範圍"
      },
      {
        name: "二、我們如何收集和使用您的用戶信息"
      },
      {
        name: "三、我們如何共享、轉讓、公開披露您的用戶信息"
      },
      {
        name: "四、用戶業務數據和公開信息"
      },
      {
        name: "五、您如何管理您的用戶信息"
      },
      {
        name: "六、我們如何保護和保存您的用戶信息"
      },
      {
        name: "七、未成年人用戶信息的特別約定"
      },
      {
        name: "八、隱私權政策的更新"
      },
      {
        name: "九、如何聯繫我們"
      }
    ],
    numberone: "一、本協議的適用範圍",
    numberlist: [
      {
        name:
          " 1.1.本隱私權政策適用於中慧通達網站所有服務。服務包括向您提供頁面瀏覽、網站登錄服務，以及通過中慧通達網站向您提供的技術服務。"
      },
      {
        name:
          " 1.2.本隱私權政策不適用於其他第三方向您提供的服務。例如，中慧通達雲市場上的服務商依託雲市場向您提供服務時，您向服務商提供的信息不適用本隱私權政策。"
      },
      {
        name:
          " 1.3.需要特別說明的是，作爲中慧通達的用戶，若您利用中慧通達的技術服務，爲您的用戶再行提供服務，因您的業務數據屬於您所有，您應當另行與您的用戶約定隱私權政策。"
      }
    ],
    numbertwo: "二、我們如何收集和使用您的用戶信息",
    number_one: "（一）我們收集您的用戶信息的情形",
    number_onelist: [
      {
        name: "2.1.幫助您成爲我們的會員"
      },
      {
        name:
          " 2.1.1.當您在中慧通達網站創建賬戶時，您須向我們提供會員名，設置、確認您的登錄密碼，提供您在中華人民共和國境內手機號碼。您提交的手機號碼用於您註冊、登錄、綁定賬戶、密碼找回時接受驗證碼，並且作爲您與中慧通達指定的聯繫方式之一，用來接受相關業務通知（如新品上線、服務變更等）。"
      },
      {
        name:
          "  2.1.2.在您註冊完成中慧通達賬戶後，您可以在賬戶“基本資料”一欄中繼續填寫您的信息，包括（1）您的賬戶名稱、單位名稱等。"
      },
      {
        name:
          " 2.1.3.在您註冊完成中慧通達賬戶後，您需在賬號的管理控制檯提交聯繫人信息，包括您指定聯繫人的郵箱、手機號碼以及聯繫人的職位。中慧通達將通過如上信息向您推廣、介紹產品，發送業務通知（含賬單）或與您進行業務溝通。"
      },
      {
        name:
          "  2.1.4.如果您僅需使用中慧通達網站的瀏覽、搜索等基本服務，您不需要註冊成爲我們的會員及提供上述信息。"
      },
      {
        name: "2.2.向您提供技術服務"
      },
      {
        name:
          "2.2.1.根據中華人民共和國法律，在您使用具體的技術服務時，您應通過您的賬號提供您的真實身份信息。"
      }
    ],
    number_two: "（二）我們使用您的用戶信息的情形",
    number_twolist: [
      {
        name: "2.2.我們出於如下目的，使用您提交以及我們收集的用戶信息："
      },
      {
        name:
          "2.2.1. 爲了向您提供服務，我們會向您發送信息、通知或與您進行業務溝通，包括但不限於爲保證服務完成所必須的驗證碼、使用服務時所必要的推送通知；"
      },
      {
        name:
          "2.2.2. 爲了維護、改進服務，向您提供更符合您個性化需求的信息展示，我們可能將來自中慧通達網站某項服務的用戶信息與來自其他項服務的信息結合起來，做出特徵模型並進行用戶畫像，向您展示、推送信息和可能的商業廣告，包括但不限於關於中慧通達產品的新聞以及市場活動及優惠促銷信息、中慧通達合作第三方的推廣信息，或其他您可能感興趣的內容。如果您不想接收我們給您發送的商業性電子信息，您可通過短信提示回覆退訂或根據信息中提供的退訂方式予以退訂；"
      },
      {
        name:
          "2.2.3. 我們可能以用戶信息統計數據爲基礎，設計、開發、推廣全新的產品及服務；我們會對我們的服務使用情況進行統計，並可能會與公衆或第三方分享這些統計信息，但這些統計信息不包含您的任何身份識別信息；"
      },
      {
        name:
          "2.2.4. 爲提高您使用我們及我們關聯公司、合作伙伴提供服務的安全性，確保操作環境安全與識別賬號異常狀態，保護您或其他用戶或公衆的人身財產安全免遭侵害，更好地預防釣魚網站、欺詐、網絡漏洞、計算機病毒、網絡攻擊、網絡侵入等安全風險，更準確地識別違反法律法規或中慧通達相關協議、規則的情況，我們可能使用您的會員信息、並整合設備信息、有關網絡日誌以及我們關聯公司、合作伙伴合法分享的信息，來判斷您賬戶及交易風險、進行身份驗證、安全事件的檢測及防範，並依法採取必要的記錄、審計、分析、處置措施；"
      },
      {
        name:
          "2.2.5. 如超出收集用戶信息時所聲稱的目的，或者在超出具有直接或合理關聯的範圍使用用戶信息前，我們會再次向您告知並徵得您的明示同意。"
      }
    ],
    numberthree: "三、我們如何共享、轉讓、公開披露您的用戶信息",
    number_three: "3.1. 共享",
    number_threelist: [
      { name: "我們不會與其他組織和個人共享您的用戶信息，但以下情況除外：" },
      {
        name:
          "3.1.1.在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的用戶信息；"
      },
      {
        name:
          "3.1.2.在法定情形下的共享：我們可能會根據法律法規規定、訴訟、仲裁解決需要，或按行政、司法機關依法提出的要求，對外共享您的用戶信息；"
      },
      {
        name:
          "3.1.3.爲了促成交易或協助解決爭議，某些情況下只有共享您的用戶信息，才能促成交易或處理您與他人的糾紛或爭議，例如，在中慧通達雲市場上創建的某一交易中，如交易任何一方履行或部分履行了交易義務並提出信息披露請求的，中慧通達有權決定向該用戶提供其交易對方的聯絡方式等必要信息，以促成交易的完成；"
      },
      {
        name:
          "3.1.4.與授權合作伙伴共享：我們可能委託受信賴的合作伙伴來提供服務，因此我們可能會與合作伙伴共享您的某些用戶信息，以提供更好的客戶服務和優化用戶體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的用戶信息，並且只會共享提供服務所必要的用戶信息。我們的合作伙伴無權將共享的用戶信息用於任何其他用途。目前，我們的授權合作伙伴包括如下類型：供應商、服務提供商和其他合作伙伴。我們將信息發送給支持我們業務的供應商、服務提供商和其他合作伙伴，這些支持包括提供基礎技術服務、提供諮詢、分析等專業服務。對我們與之共享用戶信息的公司、組織和個人，我們會與其簽署嚴格的保密協議以及信息保護約定，要求他們按照我們的說明、本隱私權政策以及其他任何相關的保密和安全措施來處理用戶信息。"
      }
    ],
    three_two: "3.2. 轉讓",
    three_two_list: [
      {
        name:
          "我們不會將您的用戶信息轉讓給任何公司、組織和個人，但以下情況除外："
      },
      {
        name:
          "3.2.1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的用戶信息；"
      },
      {
        name:
          "3.2.2. 在中慧通達與其他法律主體者發生合併、收購或破產清算情形，或其他涉及合併、收購或破產清算情形時，如涉及到用戶信息轉讓，我們會要求新的持有您用戶信息的公司、組織繼續受本政策的約束，否則我們將要求該公司、組織和個人重新向您徵求授權同意。"
      }
    ],
    numberthree: "三、我們如何共享、轉讓、公開披露您的用戶信息",
    number_three: "3.1. 共享",
    number_threelist: [
      { name: "我們不會與其他組織和個人共享您的用戶信息，但以下情況除外：" },
      {
        name:
          "3.1.1.在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的用戶信息；"
      },
      {
        name:
          "3.1.2.在法定情形下的共享：我們可能會根據法律法規規定、訴訟、仲裁解決需要，或按行政、司法機關依法提出的要求，對外共享您的用戶信息；"
      },
      {
        name:
          "3.1.3.爲了促成交易或協助解決爭議，某些情況下只有共享您的用戶信息，才能促成交易或處理您與他人的糾紛或爭議，例如，在中慧通達雲市場上創建的某一交易中，如交易任何一方履行或部分履行了交易義務並提出信息披露請求的，中慧通達有權決定向該用戶提供其交易對方的聯絡方式等必要信息，以促成交易的完成；"
      },
      {
        name:
          "3.1.4.與授權合作伙伴共享：我們可能委託受信賴的合作伙伴來提供服務，因此我們可能會與合作伙伴共享您的某些用戶信息，以提供更好的客戶服務和優化用戶體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的用戶信息，並且只會共享提供服務所必要的用戶信息。我們的合作伙伴無權將共享的用戶信息用於任何其他用途。目前，我們的授權合作伙伴包括如下類型：供應商、服務提供商和其他合作伙伴。我們將信息發送給支持我們業務的供應商、服務提供商和其他合作伙伴，這些支持包括提供基礎技術服務、提供諮詢、分析等專業服務。對我們與之共享用戶信息的公司、組織和個人，我們會與其簽署嚴格的保密協議以及信息保護約定，要求他們按照我們的說明、本隱私權政策以及其他任何相關的保密和安全措施來處理用戶信息。"
      }
    ],
    three_two: "3.2. 轉讓",
    three_two_list: [
      {
        name:
          "我們不會將您的用戶信息轉讓給任何公司、組織和個人，但以下情況除外："
      },
      {
        name:
          "3.2.1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的用戶信息；"
      },
      {
        name:
          "3.2.2. 在中慧通達與其他法律主體者發生合併、收購或破產清算情形，或其他涉及合併、收購或破產清算情形時，如涉及到用戶信息轉讓，我們會要求新的持有您用戶信息的公司、組織繼續受本政策的約束，否則我們將要求該公司、組織和個人重新向您徵求授權同意。"
      }
    ],
    // 四
    numberthree: "三、我們如何共享、轉讓、公開披露您的用戶信息",
    number_three: "3.1. 共享",
    number_threelist: [
      { name: "我們不會與其他組織和個人共享您的用戶信息，但以下情況除外：" },
      {
        name:
          "3.1.1.在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的用戶信息；"
      },
      {
        name:
          "3.1.2.在法定情形下的共享：我們可能會根據法律法規規定、訴訟、仲裁解決需要，或按行政、司法機關依法提出的要求，對外共享您的用戶信息；"
      },
      {
        name:
          "3.1.3.爲了促成交易或協助解決爭議，某些情況下只有共享您的用戶信息，才能促成交易或處理您與他人的糾紛或爭議，例如，在中慧通達雲市場上創建的某一交易中，如交易任何一方履行或部分履行了交易義務並提出信息披露請求的，中慧通達有權決定向該用戶提供其交易對方的聯絡方式等必要信息，以促成交易的完成；"
      },
      {
        name:
          "3.1.4.與授權合作伙伴共享：我們可能委託受信賴的合作伙伴來提供服務，因此我們可能會與合作伙伴共享您的某些用戶信息，以提供更好的客戶服務和優化用戶體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的用戶信息，並且只會共享提供服務所必要的用戶信息。我們的合作伙伴無權將共享的用戶信息用於任何其他用途。目前，我們的授權合作伙伴包括如下類型：供應商、服務提供商和其他合作伙伴。我們將信息發送給支持我們業務的供應商、服務提供商和其他合作伙伴，這些支持包括提供基礎技術服務、提供諮詢、分析等專業服務。對我們與之共享用戶信息的公司、組織和個人，我們會與其簽署嚴格的保密協議以及信息保護約定，要求他們按照我們的說明、本隱私權政策以及其他任何相關的保密和安全措施來處理用戶信息。"
      }
    ],
    three_two: "3.2. 轉讓",
    three_two_list: [
      {
        name:
          "我們不會將您的用戶信息轉讓給任何公司、組織和個人，但以下情況除外："
      },
      {
        name:
          "3.2.1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的用戶信息；"
      },
      {
        name:
          "3.2.2. 在中慧通達與其他法律主體者發生合併、收購或破產清算情形，或其他涉及合併、收購或破產清算情形時，如涉及到用戶信息轉讓，我們會要求新的持有您用戶信息的公司、組織繼續受本政策的約束，否則我們將要求該公司、組織和個人重新向您徵求授權同意。"
      }
    ],
    // 五、
    numberthree: "三、我們如何共享、轉讓、公開披露您的用戶信息",
    number_three: "3.1. 共享",
    number_threelist: [
      { name: "我們不會與其他組織和個人共享您的用戶信息，但以下情況除外：" },
      {
        name:
          "3.1.1.在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的用戶信息；"
      },
      {
        name:
          "3.1.2.在法定情形下的共享：我們可能會根據法律法規規定、訴訟、仲裁解決需要，或按行政、司法機關依法提出的要求，對外共享您的用戶信息；"
      },
      {
        name:
          "3.1.3.爲了促成交易或協助解決爭議，某些情況下只有共享您的用戶信息，才能促成交易或處理您與他人的糾紛或爭議，例如，在中慧通達雲市場上創建的某一交易中，如交易任何一方履行或部分履行了交易義務並提出信息披露請求的，中慧通達有權決定向該用戶提供其交易對方的聯絡方式等必要信息，以促成交易的完成；"
      },
      {
        name:
          "3.1.4.與授權合作伙伴共享：我們可能委託受信賴的合作伙伴來提供服務，因此我們可能會與合作伙伴共享您的某些用戶信息，以提供更好的客戶服務和優化用戶體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的用戶信息，並且只會共享提供服務所必要的用戶信息。我們的合作伙伴無權將共享的用戶信息用於任何其他用途。目前，我們的授權合作伙伴包括如下類型：供應商、服務提供商和其他合作伙伴。我們將信息發送給支持我們業務的供應商、服務提供商和其他合作伙伴，這些支持包括提供基礎技術服務、提供諮詢、分析等專業服務。對我們與之共享用戶信息的公司、組織和個人，我們會與其簽署嚴格的保密協議以及信息保護約定，要求他們按照我們的說明、本隱私權政策以及其他任何相關的保密和安全措施來處理用戶信息。"
      }
    ],
    three_two: "3.2. 轉讓",
    three_two_list: [
      {
        name:
          "我們不會將您的用戶信息轉讓給任何公司、組織和個人，但以下情況除外："
      },
      {
        name:
          "3.2.1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的用戶信息；"
      },
      {
        name:
          "3.2.2. 在中慧通達與其他法律主體者發生合併、收購或破產清算情形，或其他涉及合併、收購或破產清算情形時，如涉及到用戶信息轉讓，我們會要求新的持有您用戶信息的公司、組織繼續受本政策的約束，否則我們將要求該公司、組織和個人重新向您徵求授權同意。"
      }
    ],
    three_three: "3.3.公開披露",
    three_three_list: [
      {
        name: "我們僅會在以下情况下，公開披露您的用戶資訊："
      },
      {
        name:
          " 3.3.1.獲得您明確同意或基於您的主動選擇，我們可能會公開披露您的用戶資訊；"
      },
      {
        name:
          "3.3.2.或為保護天弛網絡平臺及其關聯公司用戶或公眾的人身財產安全免遭侵害，我們可能依據適用的法律或天弛網絡平臺相關協定、規則披露關於您的用戶資訊。例如，若您作為雲市場服務商銷售假貨或盜版商品，我們可能會公開披露您的店鋪主體資訊與處罰情况。"
      }
    ],
    three_four: "3.4.共亯、轉讓、公開披露用戶資訊時事先征得授權同意的例外",
    three_four_list: [
      {
        name:
          "以下情形中，共亯、轉讓、公開披露您的用戶資訊無需事先征得您的授權同意："
      },
      {
        name: "3.4.1.與國家安全、國防安全有關的；"
      },
      {
        name: "3.4.2.與公共安全、公共衛生、重大公共利益有關的；"
      },
      {
        name: "3.4.3.與犯罪偵查、起訴、審判和判决執行等有關的；"
      },
      {
        name:
          "3.4.4.出於維護您或其他個人的生命、財產等重大合法權益但又很難得到本人同意的；"
      },
      {
        name: "3.4.5.您自行向社會公眾公開的個人資訊；"
      },
      {
        name:
          " 3.4.6.從合法公開披露的資訊中收集個人資訊的，如合法的新聞報導、政府資訊公開等通路。"
      }
    ],

    four: "四、用戶業務數據和公開信息",
fourtext:
"不同於您的用戶信息，對於用戶業務數據和公開信息，天弛網絡將按如下方式處理：",
four_one: "4.1.用戶業務數據",
four_one_list: [
{
name:"4.1.1.您通過天弛網絡提供的服務，加工、存儲、上傳、下載、分發以及通過其他方式處理的數據，均爲您的用戶業務數據，您完全擁有您的用戶業務數據。天弛網絡作爲雲服務提供商，我們只會嚴格執行您的指示處理您的業務數據，除按與您協商一致或執行明確的法律法規要求外，不對您的業務數據進行任何非授權的使用或披露。"
},
{
name:
"4.1.2.您應對您的用戶業務數據來源及內容負責，天弛網絡提示您謹慎判斷數據來源及內容的合法性。因您的用戶業務數據內容違反法律法規、部門規章或國家政策而造成的全部結果及責任均由您自行承擔。"
},
{
name:
"4.1.3.根據您與天弛網絡協商一致，天弛網絡在您選定的數據中心存儲用戶業務數據。天弛網絡恪守對用戶的安全承諾，根據適用的法律保護用戶存儲在天弛網絡數據中心的數據。"
}
],
four_one_text: [
{
name:
"4.2.2. 不應出現任何破壞或試圖破壞網絡安全等的行爲，包括不會利用技術或其他手段破壞或擾亂本網站及天弛網絡其他客戶的網站；"
},
{
name:
" 4.2.3. 您使用天弛網絡網站的服務應符合本服務條款；如您違反上述保證，天弛網絡除有權根據相關服務條款採取刪除信息、中止服務、終止服務的措施，並有權凍結或註銷您賬戶部分或全部功能。"
}
],
four_two: "4.2.公開信息",
four_two_list: [
{
name:
"4.2.1.公開信息是指您公開分享的任何信息，任何人都可以在使用和未使用天弛網絡網站服務期間查看或訪問這些信息。例如您在天弛網絡開發者論壇發佈的信息。"
},
{
name:
"4.2.2.爲使用天弛網絡網站服務，可能存在您必須公開分享的信息。例如雲市場爲構建誠信交易環境，您的信用評價信息（星級、客戶評價）需要被公開分享。若您是服務商（賣家），您應當根據適用的法律法規和天弛網絡雲市場規則的要求，公開分享企業或者自然人經營者的相關信息。"
},
{
name:"4.2.3.在使用天弛網絡網站的雲市場進行交易時，您不可避免的要向交易對方或潛在的交易對方披露自己的個人信息，如聯絡方式或者郵政地址。請您妥善保護自己的個人信息，僅在必要的情形下向他人提供。您也可以通過我們的服務建立聯繫和相互分享。當您通過我們的服務創建交流、交易或分享時，您可以自主選擇溝通、交易或分享的對象，作爲能夠看到您的聯絡方式、交流信息或分享內容等相關信息的第三方。如您發現自己的個人信息泄漏，尤其是您的賬戶或密碼發生泄露，請您立即聯絡天弛網絡客服，以便天弛網絡採取相應措施。"
}
],
five: "五、您如何管理您的用戶信息",
five_list: [
{
name:
"5.1.您可以登錄天弛網絡網站或客戶端“管理控制檯”查詢、管理（變更、刪除）使用天弛網絡服務時而提交的基本業務信息（基本資料）和聯繫人信息。"
},
{
name:
"5.2. 如果您需要變更您天弛網絡賬戶的信息，您需登錄天弛網絡網站進行信息修改。"
},
{
name: "5.3. 在以下情形中，您可以向我們提出刪除用戶信息的請求："
},
{
name: "5.3.1. 如果我們處理用戶信息的行爲違反法律法規；"
},
{
name: "5.3.3. 如果我們處理個人信息的行爲嚴重違反了與您的約定。"
},
{
name:
"5.4 每個業務功能需要一些基本的用戶信息才能得以完成（見本隱私權政策第二條）。除此之外，您可以在與天弛網絡客服聯繫給予或收回您的授權同意。當您收回同意後，我們將不再處理相應的用戶信息。但您收回同意的決定，不會影響此前基於您的授權而開展的用戶信息處理。"
},
],
seven: "六、我們如何保護和保存您的用戶信息",
seven_list: [
{
name:
"6.1. 天弛網絡非常重視您的信息安全。我們努力採取各種合理的物理、電子和管理方面的安全措施來保護您的用戶信息。防止用戶信息遭到未經授權訪問、公開披露、使用、修改、損壞或丟失。我們會使用加密技術提高用戶信息的安全性；我們會使用受信賴的保護機制防止用戶信息遭到惡意攻擊；我們會部署訪問控制機制，盡力確保只有授權人員纔可訪問用戶信息；以及我們會舉辦安全和隱私保護培訓課程，加強員工對於保護用戶信息重要性的認識。"
},
{
name:
" 6.2. 我們會採取合理可行的措施，盡力避免收集無關的用戶信息。我們只會在達成本政策所述目的所需的期限內保留您的用戶信息，除非受到法律的允許。超出上述用戶信息保存期限後，我們會對您的個人信息進行刪除或匿名化處理。"
},
{
name:
"6.3. 請使用複雜密碼，協助我們保證您的賬號安全。我們將盡力保障您發送給我們的任何信息的安全性。如果我們的物理、技術或管理防護設施遭到破壞，導致信息被非授權訪問、公開披露、篡改或毀壞，導致您的合法權益受損，我們將承擔相應的法律責任。"
},
{
name:
"6.4. 在不幸發生用戶信息安全事件（泄露、丟失等）後，我們將按照法律法規的要求，及時向您告知：安全事件的基本情況和可能的影響、我們已採取或將要採取的處置措施、您可自主防範和降低風險的建議、對您的補救措施等。我們將及時將事件相關情況以郵件、信函、電話、推送通知等方式告知您，難以逐一告知用戶信息主體時，我們會採取合理、有效的方式發佈公告。"
},
{
name:
"6.5. 同時，我們還將按照監管部門要求，上報用戶信息安全事件的處置情況。"
},
{
name:
"6.6. 我們將收集到的您的用戶信息存放在中華人民共和國境內，如在符合適用法律規定的情形下因業務需要向境外傳輸個人信息的，我們會事先徵得您的同意，並向您告知用戶信息出境的目的、接收方、安全保障措施、安全風險等情況。"
},
{
name:
"6.7. 如出現天弛網絡產品和服務停止運營的情形，我們會採取合理措施保護您用戶信息安全，包括及時停止繼續收集用戶信息的活動；停止運營的通知將以逐一送達或公告的形式通知用戶；並對所持有的個人信息進行刪除或匿名化處理等。"
}
],
    eight: "七、未成年人用戶信息的特別約定",
    eight_list: [
      {
        name:
          "7.1.我們主要面向成人提供產品和服務。如您爲未成年人，我們要求您請您的父母或監護人仔細閱讀本隱私權政策，並在徵得您的父母或監護人同意的前提下使用我們的服務或向我們提供信息。"
      },
      {
        name:
          "7.2.對於經父母或監護人同意使用我們的產品或服務而收集未成年人個人信息的情況，我們只會在法律法規允許、父母或監護人明確同意或者保護未成年人所必要的情況下使用、共享、轉讓或披露此信息。"
      }
    ],
    nine: "八、隱私權政策的更新",
    nine_list: [
      { name: " 8.1. 我們的隱私權政策可能修訂。" },
      {
        name:
          "8.2. 未經您明確同意，我們不會限制您按照本隱私權政策所應享有的權利。我們會在專門頁面上發佈對隱私權政策所做的任何修訂。"
      },
      {
        name:
          "8.3. 對於重大修訂，我們還會提供更爲顯著的通知（包括對於某些服務，我們會通過網站公示的方式進行通知甚至向您提供彈窗提示，說明隱私權政策的具體變更內容）。"
      },
      { name: "8.4. 本政策所指的重大變更包括但不限於：" },
      {
        name:
          "8.4.1. 我們的服務模式發生重大變化。如處理用戶信息的目的、處理的用戶信息類型、用戶信息的使用方式等；"
      },
      {
        name:
          " 8.4.2. 我們在控制權、組織架構等方面發生重大變化。如業務調整、破產併購等引起的所有者變更等；"
      },
      { name: "8.4.3.用戶信息共享、轉讓或公開披露的主要對象發生變化；" },
      { name: "8.4.4. 您參與用戶信息處理方面的權利及其行使方式發生重大變化；" },
      {
        name:
          "8.4.5. 我們負責處理用戶信息安全的責任部門、聯絡方式及投訴渠道發生變化時；"
      },
      { name: "8.4.6. 用戶信息安全影響評估報告表明存在高風險時。" }
    ],
    ten: "九、如何聯繫我們",
    ten_list: [
      {
        name:
          "您對本聲明和政策內容有任何疑問和意見，或者您對中慧通達對本隱私權政策的實踐以及操作上有任何疑問和意見，您可通過中慧通達的工單、建議提交平臺與我們聯繫。"
      }
    ]
  },
  ...zhLocale
};

export default zh;
